import React, { useState, useEffect, useMemo, useRef } from "react";
import "./register.css";
import {
  FaPlus as Plus,
  FaMinus as Minus,
  FaTrash as Trash2,
  FaSearch,
  FaCheckDouble,
} from "react-icons/fa";
import { Alert } from "react-bootstrap";
import {
  AttendeesUpdate,
  GuestAtendeeUpdate,
  GetAttendee,
  uploadFilesAWS,
  GetMemberDetails,
  GetMemberAllDetails,
} from "../../../../api/Webservices";
import { useRegistration } from "../../../../context/RegistrationContext";
import { showToast, ToastMessage } from "../../../Shared/ToastMessage";
import { FaChevronUp, FaInfoCircle } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import FileUploadField from "../Registerutils/FileUploadField";
const AttendeeDetails = ({ selectedTickets, onProceed, onBack, eventData }) => {
  console.log("eventDataAttendee", eventData);

  const { registrationData } = useRegistration();
  const [isDetailsVisible, setIsDetailsVisible] = useState(false);
  const [expandedTickets, setExpandedTickets] = useState([]);
  const [buyerFormDetails, setBuyerFormDetails] = useState([]);
  const [allFormsData, setAllFormsData] = useState({});
  const [errors, setErrors] = useState({});
  const [activeTicketTab, setActiveTicketTab] = useState(0);
  const [activeAttendeeTab, setActiveAttendeeTab] = useState({});
  const [savedAttendees, setSavedAttendees] = useState({});
  const [fetchedTickets, setFetchedTickets] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUploading, setIsUploading] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [membershipNumber, setMemberShipNumber] = useState("");
  // ── right after the other useState declarations ──
  // ── JavaScript (no TypeScript) ──
  const [verifiedMemberships, setVerifiedMemberships] = useState({});
  const [verifiedMembershipNumbers, setVerifiedMembershipNumbers] = useState(
    {}
  );
  const stateIsSame = eventData?.state_is_same === "yes";
  const taxName = stateIsSame ? "SGST & CGST" : "IGST";

  const log = (...args) => {};

  const createExpandedTickets = () => {
    const expanded = [];
    let ticketTabIndex = 0;
    const attendeeIds = registrationData?.attendee_ids || [];
    let attendeeIdIndex = 0;

    selectedTickets.forEach((originalTicket) => {
      let ticketData = originalTicket;
      if (typeof originalTicket.ticket_data === "string") {
        try {
          ticketData = JSON.parse(
            originalTicket.ticket_data
              .replace(/^"|"$/g, "")
              .replace(/\\"/g, '"')
          );
        } catch (error) {
          console.log(
            `Failed to parse ticket_data for ticket ${originalTicket.id}:`,
            error
          );
          ticketData = originalTicket;
        }
      }

      const mainTicketQuantity = ticketData.ticketQuantity || 1;

      if (mainTicketQuantity > 0) {
        const attendeeInstances = [];
        for (let i = 0; i < mainTicketQuantity; i++) {
          const assignedId =
            attendeeIdIndex < attendeeIds.length
              ? attendeeIds[attendeeIdIndex++]
              : null;
          attendeeInstances.push({
            attendeeIndex: i,
            attendeeId: `${ticketData.id}-main-${i}`,
            assignedAttendeeId: assignedId,
          });
        }

        let mainFormDetails = [];
        try {
          let formDetailsRaw = ticketData.form_details;
          if (typeof formDetailsRaw === "string") {
            formDetailsRaw = formDetailsRaw
              .replace(/^"|"$/g, "")
              .replace(/\\"/g, '"');
            mainFormDetails = JSON.parse(formDetailsRaw);
          } else if (Array.isArray(formDetailsRaw)) {
            mainFormDetails = formDetailsRaw;
          }
        } catch (error) {
          console.log(
            `Failed to parse main form_details for ticket ${ticketData.id}:`,
            error
          );
          mainFormDetails = [];
        }

        let addons = [];
        try {
          if (typeof ticketData.addons === "string") {
            addons = JSON.parse(
              ticketData.addons.replace(/^"|"$/g, "").replace(/\\"/g, '"')
            );
          } else if (Array.isArray(ticketData.addons)) {
            addons = ticketData.addons;
          }
        } catch (error) {
          console.log(
            `Failed to parse addons for ticket ${ticketData.id}:`,
            error
          );
          addons = [];
        }

        expanded.push({
          ...ticketData,
          ticketTabIndex: ticketTabIndex++,
          instanceId: `${ticketData.id}-main`,
          instanceType: "main",
          instanceIndex: 0,
          originalTicketId: ticketData.id,
          displayTitle: ticketData.title || `Ticket ${ticketData.id}`,
          attendeeInstances,
          form_details: mainFormDetails,
          addons,
        });
      }

      if (ticketData.guestCount > 0) {
        for (let i = 0; i < ticketData.guestCount; i++) {
          let guestFormDetails = [];
          try {
            if (
              ticketData.guest_details &&
              typeof ticketData.guest_details.form_details === "string"
            ) {
              let guestFormDetailsRaw = ticketData.guest_details.form_details;
              guestFormDetailsRaw = guestFormDetailsRaw
                .replace(/^"|"$/g, "")
                .replace(/\\"/g, '"');
              const parsedForm = JSON.parse(guestFormDetailsRaw);
              guestFormDetails = Array.isArray(parsedForm.fields)
                ? parsedForm.fields
                : [];
            } else if (Array.isArray(ticketData.guest_details?.form_details)) {
              guestFormDetails = ticketData.guest_details.form_details;
            }
          } catch (error) {
            console.log(
              `Failed to parse guest form_details for ${ticketData.id}-guest-${i}:`,
              error
            );
            guestFormDetails = [];
          }

          expanded.push({
            ...ticketData,
            ticketTabIndex: ticketTabIndex++,
            instanceId: `${ticketData.id}-guest-${i}`,
            instanceType: "guest",
            instanceIndex: i,
            originalTicketId: ticketData.id,
            displayTitle:
              ticketData.guest_details?.ticket_name ||
              `Accompanying Person ${i + 1}`,
            price: ticketData.guestPrice || 0,
            form_details: guestFormDetails,
            addons: ticketData.addons || [],
            attendeeInstances: [
              {
                attendeeIndex: 0,
                attendeeId: `${ticketData.id}-guest-${i}`,
                assignedAttendeeId: null,
              },
            ],
          });
        }
      }
    });

    return expanded;
  };
  const membershipTimeoutRef = useRef(null);

  const fetchMemberDetails = useRef((attendeeId, membershipNumber) => {
    if (membershipTimeoutRef.current) {
      clearTimeout(membershipTimeoutRef.current);
    }

    membershipTimeoutRef.current = setTimeout(async () => {
      if (!membershipNumber || membershipNumber.trim() === "") return;

      try {
        // showToast("Fetching member details...", "info");
        // const response = await GetMemberAllDetails({
        //   email_or_phone: membershipNumber.trim(),
        // });
        const response = await GetMemberAllDetails(membershipNumber.trim());

        // CASE 1: API success, but no data found
        if (
          response.success === true &&
          (!response.data || response.data.length === 0)
        ) {
          setVerifiedMemberships((prev) => {
            const { [attendeeId]: _, ...rest } = prev;
            return rest;
          });

          showToast("No member found with this number", "info");
          return;
        }

        // CASE 2: API success, data exists
        if (response.success === true && response.data) {
          // const membershipNo = response.data[0].membership_no;
          // setVerifiedMembershipNumbers((prev) => ({
          //   ...prev,
          //   [attendeeId]: membershipNo,
          // }));
          // setMemberShipNumber(membershipNo);
          // const memberData = response.data[0];
          // const rawMappings = {
          //   first_name: memberData.first_name || memberData.firstname,
          //   last_name: memberData.last_name || memberData.lastname,
          //   email_address: memberData.email || memberData.email_address,
          // };
          const membershipNo = response.data.data.amasi_number;
          setVerifiedMembershipNumbers((prev) => ({
            ...prev,
            [attendeeId]: membershipNo,
          }));
          setMemberShipNumber(membershipNo);
          const memberData = response.data.data;
          console.log("memberData: ",memberData);
          const rawMappings = {
            first_name: memberData.first_name || memberData.firstname,
            last_name: memberData.last_name || memberData.lastname,
            email_address: memberData.email || memberData.email_address,
            phone_number: (() => {
              const phone = memberData.mobile || memberData.phone_number;
              if (!phone) return null;
              
              const digits = String(phone).replace(/\D/g, '');
              return digits.length >= 10 ? digits.slice(-10) : digits;
            })(),
          };
         
          // Update form data
          setAllFormsData((prev) => {
            const attendeeData = prev[attendeeId] || {};
            const updatedFormData = { ...attendeeData.formData };

            Object.entries(rawMappings).forEach(([nameKey, value]) => {
              if (!value) return;
              const matchingField = attendeeData.formDetails?.find(
                (f) => f.name === nameKey
              );
              if (matchingField?.id) {
                updatedFormData[matchingField.id] = value;
              }
            });

            return {
              ...prev,
              [attendeeId]: {
                ...attendeeData,
                formData: updatedFormData,
              },
            };
          });

          // Clear errors for auto-filled fields
          setErrors((prev) => {
            const newErrors = { ...prev };
            Object.keys(rawMappings).forEach((nameKey) => {
              const field = allFormsData[attendeeId]?.formDetails?.find(
                (f) => f.name === nameKey
              );
              if (field) {
                delete newErrors[`${attendeeId}-${field.id}`];
              }
            });
            return newErrors;
          });

          // Mark as verified
          setVerifiedMemberships((prev) => ({
            ...prev,
            [attendeeId]: true,
          }));

          showToast("Member details loaded successfully!", "success");
          return;
        }

        // CASE 3: API returned status false (invalid/inactive membership?)
        if (response.status === false) {
          setVerifiedMemberships((prev) => {
            const { [attendeeId]: _, ...rest } = prev;
            return rest;
          });
          showToast(
            "Invalid membership number. Please check and try again.",
            "error"
          );
          return;
        }
      } catch (error) {
        console.error("Error fetching member details:", error);
        setVerifiedMemberships((prev) => {
          const { [attendeeId]: _, ...rest } = prev;
          return rest;
        });

        const errorMsg =
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch member details. Please try again.";
        showToast(errorMsg, "error");
      }
    }, 500);
  }).current;
  const handleBack = () => {
    const currentAttendeeIndex = activeAttendeeTab[activeTicketTab] || 0;

    if (currentAttendeeIndex > 0) {
      setActiveAttendeeTab((prev) => ({
        ...prev,
        [activeTicketTab]: currentAttendeeIndex - 1,
      }));
    } else {
      onBack();
    }
  };

  const parseBuyerForm = () => {
    let buyerFormDetails = [];
    if (eventData?.settings?.buyer_form && eventData?.buyerForm) {
      const buyerForm = eventData.buyerForm.find(
        (form) => form.id === eventData.settings.buyer_form
      );
      if (buyerForm && buyerForm.fileds) {
        try {
          let filedsRaw = buyerForm.fileds;
          filedsRaw = filedsRaw.replace(/^"|"$/g, "").replace(/\\"/g, '"');
          buyerFormDetails = JSON.parse(filedsRaw);
        } catch (error) {
          console.log("Failed to parse buyer form fields:", error);
        }
      }
    }
    return buyerFormDetails;
  };

  useEffect(() => {
    console.log("Initializing expanded tickets and buyer form");
    const expanded = createExpandedTickets();
    setExpandedTickets(expanded);
    const buyerForm = parseBuyerForm();
    setBuyerFormDetails(buyerForm);

    const initialData = {};

    expanded.forEach((ticket) => {
      const formDetails = Array.isArray(ticket.form_details)
        ? ticket.form_details
        : [];
      const addons = ticket.addons || [];

      ticket.attendeeInstances.forEach((attendeeInstance) => {
        const attendeeFormData = formDetails.reduce((acc, field) => {
          if (field.type === "checkbox") {
            return {
              ...acc,
              [field.id]: field.options ? field.options.map(() => false) : [],
            };
          } else if (field.type === "radio" || field.type === "select") {
            return { ...acc, [field.id]: "" };
          } else if (field.type === "file") {
            return { ...acc, [field.id]: null };
          }
          return { ...acc, [field.id]: "" };
        }, {});

        const attendeeAddons = addons.map((addon) => ({
          ...addon,
          isAdded: addon.isMandatory || false,
          quantity: addon.isMandatory ? 1 : 0,
          selectedVariants: addon.addons_type === "variant" ? [] : undefined,
        }));

        initialData[attendeeInstance.attendeeId] = {
          formData: attendeeFormData,
          formDetails,
          addons: attendeeAddons,
          ticketId: ticket.originalTicketId,
          type: ticket.instanceType,
          assigned_attendee_id: attendeeInstance.assignedAttendeeId,
          ...(ticket.instanceType === "guest" ? { selectedMain: "" } : {}),
        };
      });
    });

    const buyerFormData = buyerFormDetails.reduce((acc, field) => {
      if (field.type === "checkbox") {
        return {
          ...acc,
          [field.id]: field.options ? field.options.map(() => false) : [],
        };
      } else if (field.type === "radio" || field.type === "select") {
        return { ...acc, [field.id]: "" };
      } else if (field.type === "file") {
        return { ...acc, [field.id]: null };
      }
      return { ...acc, [field.id]: "" };
    }, {});

    initialData["buyer-form"] = {
      formData: buyerFormData,
      formDetails: buyerFormDetails,
      addons: [],
    };

    setAllFormsData(initialData);
  }, [selectedTickets, eventData, registrationData]);

  const mainAttendees = useMemo(() => {
    let list = [];
    expandedTickets.forEach((ticket) => {
      if (ticket.instanceType === "main") {
        ticket.attendeeInstances.forEach((inst, idx) => {
          const formData = allFormsData[inst.attendeeId]?.formData || {};
          const firstName =
            formData[
              Object.keys(formData).find((k) => k.includes("firstname"))
            ] || "";
          const lastName =
            formData[
              Object.keys(formData).find((k) => k.includes("lastname"))
            ] || "";
          const name =
            firstName || lastName
              ? `${firstName} ${lastName}`.trim()
              : `Attendee ${idx + 1} (ID: ${inst.assignedAttendeeId || "N/A"})`;
          list.push({
            value: inst.attendeeId,
            label: `${ticket.displayTitle} - ${name}`,
            backendId: inst.assignedAttendeeId,
          });
        });
      }
    });

    return list;
  }, [expandedTickets, allFormsData]);

  useEffect(() => {
    expandedTickets.forEach((ticket) => {
      if (ticket.instanceType === "guest") {
        ticket.attendeeInstances.forEach((inst) => {
          const attendeeId = inst.attendeeId;
          const selected = allFormsData[attendeeId]?.selectedMain;
          const possibleMains = mainAttendees.filter((m) =>
            m.value.startsWith(ticket.originalTicketId + "-main-")
          );
          if (!selected && possibleMains.length === 1) {
            setAllFormsData((prev) => ({
              ...prev,
              [attendeeId]: {
                ...prev[attendeeId],
                selectedMain: possibleMains[0].value,
              },
            }));
          }
        });
      }
    });
  }, [mainAttendees, expandedTickets, allFormsData]);

  const fetchAttendeeData = async (ticketTabIndex) => {
    setIsSubmitting(true);
    setErrorMessage("");

    const currentTicket = expandedTickets[ticketTabIndex];
    if (!currentTicket) {
      setIsSubmitting(false);
      return;
    }

    const attendeeIds = currentTicket.attendeeInstances
      .map((instance) => instance.assignedAttendeeId)
      .filter((id) => id);

    const fetchedAttendees = {};

    for (const attendeeId of attendeeIds) {
      try {
        const response = await GetAttendee(attendeeId);

        const attendeeData = response.data.data[0];
        let formDataParsed = [];
        let addOnsDataParsed = [];
        let ticketDataParsed = {};
        let guestDataParsed = [];

        try {
          formDataParsed = JSON.parse(attendeeData.form_data || "[]");
          addOnsDataParsed = JSON.parse(attendeeData.add_ons_data || "[]");
          ticketDataParsed = JSON.parse(attendeeData.ticket_data || "{}");
          guestDataParsed = JSON.parse(attendeeData.guest_data || "[]");
        } catch (error) {
          console.log(
            `Failed to parse data for attendee ${attendeeId}:`,
            error
          );
          setErrorMessage(`Failed to parse data for attendee ${attendeeId}.`);
          continue;
        }

        const attendeeInstance = currentTicket.attendeeInstances.find(
          (inst) => inst.assignedAttendeeId === attendeeId
        );
        if (!attendeeInstance) {
          console.log(
            `No matching attendee instance for backend ID ${attendeeId}`
          );
          setErrorMessage(`No matching attendee instance for ${attendeeId}.`);
          continue;
        }
        const attendeeInstanceId = attendeeInstance.attendeeId;

        if (currentTicket.instanceType === "main") {
          const formDetails = Array.isArray(currentTicket.form_details)
            ? currentTicket.form_details
            : [];
          const formData = formDetails.reduce((acc, field) => {
            let fieldValue = "";
            if (formDataParsed[0]?.custom_fields) {
              const matchingField = formDataParsed[0].custom_fields.find(
                (f) => f.id === field.id
              );
              fieldValue = matchingField ? matchingField.value : "";
            }
            if (field.type === "checkbox") {
              const options = field.options || [];
              const values = fieldValue ? fieldValue.split(", ") : [];
              return {
                ...acc,
                [field.id]: options.map((opt) => values.includes(opt)),
              };
            } else if (field.type === "radio" || field.type === "select") {
              return { ...acc, [field.id]: fieldValue || "" };
            } else if (field.type === "file") {
              return { ...acc, [field.id]: fieldValue || null };
            }
            return { ...acc, [field.id]: fieldValue || "" };
          }, {});

          const addons =
            currentTicket.addons?.map((addon) => {
              const matchedAddon = addOnsDataParsed.find(
                (a) => a.id === addon.id
              );
              if (addon.addons_type === "variant") {
                const ticketAddon = selectedTickets
                  .find((t) => t.id === currentTicket.originalTicketId)
                  ?.addons?.find((a) => a.id === addon.id);
                const initialVariants =
                  ticketAddon?.variant_options
                    ?.filter(
                      (v) => ticketAddon.selected_variant === v.variant_name
                    )
                    ?.map((v) => ({
                      variant_name: v.variant_name,
                      variant_price: v.variant_price || 0,
                      quantity: ticketAddon.quantity || 0,
                    })) || [];
                const selectedVariants = matchedAddon?.variant
                  ? addon.variant_options
                      .filter((v) => v.name === matchedAddon.variant)
                      .map((v) => ({
                        variant_name: v.name,
                        variant_price: v.price || v.variant_price || 0,
                        quantity: matchedAddon.quantity || 1,
                      }))
                  : initialVariants;
                return {
                  ...addon,
                  isAdded: !!matchedAddon && !!matchedAddon.isAdded,
                  selectedVariants:
                    selectedVariants.length > 0 ? selectedVariants : [],
                };
              }
              return {
                ...addon,
                isAdded: !!matchedAddon && !!matchedAddon.isAdded,
                quantity: matchedAddon?.quantity || (addon.isMandatory ? 1 : 0),
                selectedVariant: matchedAddon?.variant
                  ? addon.variant_options?.find(
                      (v) => v.name === matchedAddon.variant
                    )
                  : null,
              };
            }) || [];

          fetchedAttendees[attendeeInstanceId] = {
            formData,
            formDetails,
            addons,
            assigned_attendee_id: attendeeData.id,
            ticketId: attendeeData.ticket_id,
            type: ticketDataParsed.instanceType,
          };
        }

        if (guestDataParsed.length > 0) {
          guestDataParsed.forEach((guest, guestIndex) => {
            const guestTicket = expandedTickets.find(
              (t) =>
                t.instanceType === "guest" &&
                t.originalTicketId === currentTicket.originalTicketId &&
                t.instanceIndex === guestIndex
            );
            if (!guestTicket) {
              console.log(
                `No matching guest ticket for guest index ${guestIndex} in ticket ${currentTicket.originalTicketId}`
              );
              return;
            }

            const guestAttendeeInstance = guestTicket.attendeeInstances[0];
            const formDetails = Array.isArray(guestTicket.form_details)
              ? guestTicket.form_details
              : [];
            const formData = formDetails.reduce((acc, field) => {
              let fieldValue = "";
              if (guest.custom_fields) {
                const matchingField = guest.custom_fields.find(
                  (f) => f.id === field.id
                );
                fieldValue = matchingField ? matchingField.value : "";
              }
              return { ...acc, [field.id]: fieldValue || "" };
            }, {});

            const addons =
              guestTicket.addons?.map((addon) => {
                const matchedAddon = guest.add_ons?.find(
                  (a) => a.id === addon.id
                );
                if (addon.addons_type === "variant") {
                  const selectedVariants = matchedAddon?.variant
                    ? addon.variant_options
                        .filter((v) => v.name === matchedAddon.variant)
                        .map((v) => ({
                          variant_name: v.name,
                          variant_price: v.price || v.variant_price || 0,
                          quantity: matchedAddon.quantity || 1,
                        }))
                    : [];
                  return {
                    ...addon,
                    isAdded: !!matchedAddon && !!matchedAddon.isAdded,
                    selectedVariants:
                      selectedVariants.length > 0 ? selectedVariants : [],
                  };
                }
                return {
                  ...addon,
                  isAdded: !!matchedAddon && !!matchedAddon.isAdded,
                  quantity:
                    matchedAddon?.quantity || (addon.isMandatory ? 1 : 0),
                  selectedVariant: matchedAddon?.variant
                    ? addon.variant_options?.find(
                        (v) => v.name === matchedAddon.variant
                      )
                    : null,
                };
              }) || [];

            const mainAttendeeId = guest.custom_fields?.find(
              (f) => f.id === "main_attendee_id"
            )?.value;
            const selectedMain =
              mainAttendees.find((m) => m.backendId === mainAttendeeId)
                ?.value || "";

            fetchedAttendees[guestAttendeeInstance.attendeeId] = {
              formData,
              formDetails,
              addons,
              assigned_attendee_id: null,
              ticketId: guestTicket.originalTicketId,
              type: "guest",
              selectedMain,
            };
          });
        }
      } catch (error) {
        console.log(`Failed to fetch attendee ${attendeeId}:`, error);
        setErrorMessage(`Failed to load attendee data for ID ${attendeeId}.`);
      }
    }

    setAllFormsData((prev) => {
      const updated = { ...prev };
      Object.keys(fetchedAttendees).forEach((attendeeId) => {
        updated[attendeeId] = {
          ...prev[attendeeId],
          ...fetchedAttendees[attendeeId],
        };
      });

      currentTicket.attendeeInstances.forEach((attendeeInstance) => {
        if (!updated[attendeeInstance.attendeeId]) {
          const formDetails = Array.isArray(currentTicket.form_details)
            ? currentTicket.form_details
            : [];
          updated[attendeeInstance.attendeeId] = {
            formData: formDetails.reduce((acc, field) => {
              if (field.type === "checkbox") {
                return {
                  ...acc,
                  [field.id]: field.options
                    ? field.options.map(() => false)
                    : [],
                };
              } else if (field.type === "radio" || field.type === "select") {
                return { ...acc, [field.id]: "" };
              } else if (field.type === "file") {
                return { ...acc, [field.id]: null };
              }
              return { ...acc, [field.id]: "" };
            }, {}),
            formDetails,
            addons:
              currentTicket.addons?.map((addon) => ({
                ...addon,
                isAdded: addon.isMandatory || false,
                quantity: addon.isMandatory ? 1 : 0,
                selectedVariants:
                  addon.addons_type === "variant" ? [] : undefined,
              })) || [],
            ticketId: currentTicket.originalTicketId,
            type: currentTicket.instanceType,
            assigned_attendee_id: attendeeInstance.assignedAttendeeId,
            ...(currentTicket.instanceType === "guest"
              ? { selectedMain: "" }
              : {}),
          };
        }
      });

      return updated;
    });

    setSavedAttendees((prev) => ({
      ...prev,
      ...Object.keys(fetchedAttendees).reduce(
        (acc, attendeeId) => ({ ...acc, [attendeeId]: true }),
        {}
      ),
    }));
    setIsSubmitting(false);
  };

  useEffect(() => {
    if (expandedTickets.length > 0 && !fetchedTickets[activeTicketTab]) {
      fetchAttendeeData(activeTicketTab).then(() => {
        setFetchedTickets((prev) => ({ ...prev, [activeTicketTab]: true }));
      });
    }
  }, [activeTicketTab, expandedTickets, registrationData, fetchedTickets]);

  const validateField = (field, value) => {
    if (
      field.required &&
      (!value ||
        (typeof value === "string" && value.trim() === "") ||
        (field.type === "file" && !value))
    ) {
      return `${field.label} is required`;
    }

    if (value && typeof value === "string") {
      const trimmed = value.trim();

      switch (field.type) {
        case "email":
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(trimmed)) {
            return "Please enter a valid email address";
          }
          break;

        case "tel":
        case "phone":
          // **NEW: exactly 10 digits**
          const phoneDigits = trimmed.replace(/\D/g, "");
          if (phoneDigits.length !== 10) {
            return "Phone number must be exactly 10 digits";
          }
          break;

        case "number":
          if (isNaN(trimmed) || parseFloat(trimmed) < 0) {
            return "Please enter a valid number";
          }
          break;

        default:
          break;
      }
    }

    return null;
  };

  const validateCheckbox = (field, values) => {
    if (field.required && (!values || values.every((v) => !v))) {
      return `${field.label} is required`;
    }
    return null;
  };

  const validateRadio = (field, value) => {
    if (field.required && !value) {
      return `${field.label} is required`;
    }
    return null;
  };

  const validateAddons = (attendeeId) => {
    const attendeeData = allFormsData[attendeeId];
    if (!attendeeData || !attendeeData.addons) return true;

    return attendeeData.addons.every((addon) => {
      if (
        addon.isMandatory &&
        addon.addon_status === "onsale" &&
        !addon.isAdded
      ) {
        return false;
      }
      return true;
    });
  };

  const validateAttendee = (attendeeId) => {
    const attendeeData = allFormsData[attendeeId];
    if (!attendeeData) return false;

    let isValid = true;

    // 1. Validate form fields
    if (Array.isArray(attendeeData.formDetails)) {
      attendeeData.formDetails.forEach((field) => {
        const value = attendeeData.formData[field.id];
        let error = null;

        if (field.type === "checkbox") {
          error = validateCheckbox(field, value);
        } else if (field.type === "radio" || field.type === "select") {
          error = validateRadio(field, value);
        } else {
          error = validateField(field, value);
        }

        if (error) {
          isValid = false;
        }
      });
    }

    // 2. Validate membership number (logic preserved, no setErrors)
    const membershipField = attendeeData.formDetails?.find(
      (f) => f.name === "amasimembership_number"
    );

    if (membershipField) {
      const membershipValue = attendeeData.formData[membershipField.id] || "";

      if (!membershipValue.trim()) {
        isValid = false;
      } else if (!verifiedMemberships[attendeeId]) {
        isValid = false;
      }
      // Note: Error messages are shown later via validateAllForms()
    }

    // 3. Guest: must select main attendee
    if (attendeeData.type === "guest" && !attendeeData.selectedMain) {
      isValid = false;
    }

    // 4. Mandatory add-ons
    if (!validateAddons(attendeeId)) {
      isValid = false;
    }

    return isValid;
  };

  const validateBuyerForm = () => {
    const buyerData = allFormsData["buyer-form"];
    if (!buyerData) return true;

    let isValid = true;
    if (Array.isArray(buyerData.formDetails)) {
      buyerData.formDetails.forEach((field) => {
        const value = buyerData.formData[field.id];
        let error = null;
        if (field.type === "checkbox") {
          error = validateCheckbox(field, value);
        } else if (field.type === "radio" || field.type === "select") {
          error = validateRadio(field, value);
        } else {
          error = validateField(field, value);
        }
        if (error) {
          isValid = false;
        }
        setErrors((prev) => ({
          ...prev,
          [`buyer-form-${field.id}`]: error || "",
        }));
      });
    }
    return isValid;
  };

  const isTicketComplete = (ticketIndex) => {
    const ticket = expandedTickets[ticketIndex];
    if (!ticket) return false;

    return ticket.attendeeInstances.every((attendeeInstance) => {
      const attendeeId = attendeeInstance.attendeeId;
      const attendeeData = allFormsData[attendeeId];
      if (!attendeeData) return false;

      // 1. Must be saved
      if (!savedAttendees[attendeeId]) return false;

      // 2. All required fields filled
      const hasEmptyRequired = attendeeData.formDetails?.some((field) => {
        if (!field.required) return false;
        const value = attendeeData.formData[field.id];

        if (field.type === "checkbox") {
          return !value || value.every((v) => !v);
        }
        if (field.type === "file") {
          return !value;
        }
        return !value || (typeof value === "string" && !value.trim());
      });

      if (hasEmptyRequired) return false;

      // 3. Membership number: required + verified
      const membershipField = attendeeData.formDetails?.find(
        (f) => f.name === "amasimembership_number"
      );
      if (membershipField) {
        const membershipValue = attendeeData.formData[membershipField.id] || "";
        if (!membershipValue.trim()) return false;
        if (!verifiedMemberships[attendeeId]) return false;
      }

      // 4. Guest: must select main attendee
      if (attendeeData.type === "guest" && !attendeeData.selectedMain) {
        return false;
      }

      // 5. All mandatory add-ons added
      const hasMissingMandatoryAddon = attendeeData.addons?.some(
        (addon) =>
          addon.isMandatory && addon.addon_status === "onsale" && !addon.isAdded
      );
      if (hasMissingMandatoryAddon) return false;

      return true;
    });
  };

  const areAllTicketsComplete = () => {
    const totalAttendees = expandedTickets.reduce(
      (total, ticket) => total + ticket.attendeeInstances.length,
      0
    );
    return (
      expandedTickets.every((_, index) => isTicketComplete(index)) &&
      validateBuyerForm() &&
      Object.keys(savedAttendees).length === totalAttendees &&
      Object.values(savedAttendees).every(
        (attendee) => attendee.saved && attendee.attendee_id
      )
    );
  };

  const saveCurrentAttendee = async (attendeeId, ticket) => {
    console.log("saveCurrentAttendee called with:", { attendeeId, ticket });
    setIsSubmitting(true);
    setErrorMessage("");

    const currentTicket = ticket || expandedTickets[activeTicketTab];
    const currentAttendeeIndex = activeAttendeeTab[activeTicketTab] || 0;
    const currentAttendeeInstance =
      currentTicket.attendeeInstances[currentAttendeeIndex];
    const targetAttendeeId = attendeeId || currentAttendeeInstance.attendeeId;
    const attendeeData = allFormsData[targetAttendeeId];

    if (!validateAttendee(targetAttendeeId)) {
      setIsSubmitting(false);
      validateAllForms();
      return false;
    }

    const startTime = Date.now();
    try {
      const add_ons = attendeeData.addons
        .filter((addon) => addon.isAdded)
        .map((addon) => {
          if (addon.addons_type === "variant") {
            const registered_variants = addon.selectedVariants.map((sv) => ({
              variant_name: sv.variant_name,
              quantity: sv.quantity,
            }));
            return { ...addon, registered_variants };
          }
          return {
            ...addon,
            variant: addon.selectedVariant ? addon.selectedVariant.name : null,
          };
        });

      const originalTicket = expandedTickets.find(
        (t) => t.originalTicketId === currentTicket.originalTicketId
      );
      const ticketId =
        originalTicket?.originalTicketId || currentTicket.originalTicketId;
      const formId = originalTicket?.selected_form || 1;

      let success = false;
      let newId = null;

      if (currentTicket.instanceType === "guest") {
        const selectedMain = attendeeData.selectedMain;
        const mainAttendee = mainAttendees.find(
          (m) => m.value === selectedMain
        );
        const mainAttendeeId = mainAttendee ? mainAttendee.backendId : null;

        if (!mainAttendeeId) {
          setErrorMessage("Please select a main attendee for the guest.");
          setIsSubmitting(false);
          return false;
        }

        const payload = {
          id: mainAttendeeId,
          form_id: formId,
          ticket_id: ticketId,
          guest_data: [
            {
              custom_fields: [
                ...attendeeData.formDetails.map((field) => {
                  let value = attendeeData.formData[field.id] || "";

                  if (field.name === "amasimembership_number") {
                    const verifiedNo =
                      verifiedMembershipNumbers[targetAttendeeId];
                    value = verifiedNo || value;
                  }

                  return {
                    id: field.id,
                    type: field.type,
                    label: field.label,
                    name:
                      field.name ||
                      field.label.toLowerCase().replace(/ /g, "_"),
                    value: value,
                  };
                }),
                {
                  id: "main_attendee_id",
                  type: "text",
                  label: "Main Attendee ID",
                  name: "main_attendee_id",
                  value: mainAttendeeId.toString(),
                },
              ],
              add_ons,
            },
          ],
        };

        const response = await GuestAtendeeUpdate(payload);
        success =
          response.data.success === true || response.data.success === "true";
        newId = response.data.attendee_id;
        if (!success) {
          setErrorMessage(
            response.data.message || "Failed to save guest attendee."
          );
        }
      } else {
        const attendeeIdFromTicket = attendeeData.assigned_attendee_id || null;
        const payload = {
          id: attendeeIdFromTicket,
          form_id: formId,
          ticket_id: ticketId,
          event_id: localStorage.getItem("eventId") || null,
          form_data: [
            {
              custom_fields: attendeeData.formDetails.map((field) => {
                let value = attendeeData.formData[field.id] || "";

                if (field.name === "amasimembership_number") {
                  const verifiedNo =
                    verifiedMembershipNumbers[targetAttendeeId];
                  value = verifiedNo || value;
                }

                return {
                  id: field.id,
                  type: field.type,
                  label: field.label,
                  name:
                    field.name || field.label.toLowerCase().replace(/ /g, "_"),
                  value: value,
                };
              }),
            },
          ],
          guest_data: [],
          ticket_data: {
            ...currentTicket,
            attendeeInstances: currentTicket.attendeeInstances,
          },
          first_name:
            attendeeData.formData[
              Object.keys(attendeeData.formData).find((key) =>
                key.includes("firstname")
              )
            ] || "",
          last_name:
            attendeeData.formData[
              Object.keys(attendeeData.formData).find((key) =>
                key.includes("lastname")
              )
            ] || "",
          email:
            attendeeData.formData[
              Object.keys(attendeeData.formData).find((key) =>
                key.includes("email")
              )
            ] || "",
          add_ons_data: add_ons,
        };

        const response = await AttendeesUpdate(payload);
        success =
          response.data.success === true || response.data.success === "true";
        newId = response.data.data?.[0]?.id || response.data.attendee_id;
        if (!success) {
          setErrorMessage(response.data.message || "Failed to save attendee.");
          showToast(
            response.data.message || "Failed to save attendee",
            "error"
          );
        } else if (newId && !attendeeData.assigned_attendee_id) {
          setAllFormsData((prev) => ({
            ...prev,
            [targetAttendeeId]: {
              ...prev[targetAttendeeId],
              assigned_attendee_id: newId,
            },
          }));
          setExpandedTickets((prev) =>
            prev.map((t) =>
              t.instanceId === currentTicket.instanceId
                ? {
                    ...t,
                    attendeeInstances: t.attendeeInstances.map((inst) =>
                      inst.attendeeId === targetAttendeeId
                        ? { ...inst, assignedAttendeeId: newId }
                        : inst
                    ),
                  }
                : t
            )
          );
        }
      }

      if (success) {
        const firstNameKey = Object.keys(attendeeData.formData).find((key) =>
          key.includes("firstname")
        );
        const firstName =
          attendeeData.formData[firstNameKey] ||
          (currentTicket.instanceType === "guest" ? "Guest" : "Attendee");

        setSavedAttendees((prev) => ({
          ...prev,
          [targetAttendeeId]: { saved: true, attendee_id: newId },
        }));
        showToast(`${firstName} updated successfully`, "success");
        const nextAttendeeIndex = currentAttendeeIndex + 1;
        if (nextAttendeeIndex < currentTicket.attendeeInstances.length) {
          setActiveAttendeeTab((prev) => ({
            ...prev,
            [activeTicketTab]: nextAttendeeIndex,
          }));
        } else if (activeTicketTab + 1 < expandedTickets.length) {
          setActiveTicketTab(activeTicketTab + 1);
          setActiveAttendeeTab((prev) => ({
            ...prev,
            [activeTicketTab + 1]: 0,
          }));
        }
        const elapsed = Date.now() - startTime;
        if (elapsed < 1000)
          await new Promise((resolve) => setTimeout(resolve, 1000 - elapsed));
        return true;
      }
      return false;
    } catch (err) {
      console.log("Error saving attendee:", err);
      setErrorMessage(err.response?.data?.message || "An error occurred.");
      showToast(err.response?.data?.message || "An error occurred.", "error");
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleTicketTabClick = async (index) => {
    if (index === activeTicketTab || index >= expandedTickets.length) return;

    if (activeTicketTab < index) {
      const currentTicket = expandedTickets[activeTicketTab];
      const currentAttendeeIndex = activeAttendeeTab[activeTicketTab] || 0;
      const currentAttendeeInstance =
        currentTicket.attendeeInstances[currentAttendeeIndex];

      if (!validateAttendee(currentAttendeeInstance.attendeeId)) {
        setErrorMessage(
          "Please fill all required fields and select mandatory add-ons before proceeding."
        );
        return;
      }

      const success = await saveCurrentAttendee();
      if (!success) return;
    }

    if (
      index === 0 ||
      expandedTickets.slice(0, index).every((_, i) => isTicketComplete(i))
    ) {
      setActiveTicketTab(index);
      setActiveAttendeeTab((prev) => ({ ...prev, [index]: 0 }));
    } else {
      setErrorMessage(
        "Please complete all previous tickets before proceeding."
      );
    }
  };

  const handleAttendeeTabClick = async (ticketIndex, attendeeIndex) => {
    console.log("handleAttendeeTabClick:", { ticketIndex, attendeeIndex });
    if (ticketIndex !== activeTicketTab) return;

    const currentIndex = activeAttendeeTab[ticketIndex] || 0;
    if (attendeeIndex === currentIndex) return;

    const currentTicket = expandedTickets[ticketIndex];
    const currentAttendeeInstance =
      currentTicket.attendeeInstances[currentIndex];

    if (!validateAttendee(currentAttendeeInstance.attendeeId)) {
      setErrorMessage(
        "Please fill all required fields and select mandatory add-ons before switching attendees."
      );
      return;
    }

    const success = await saveCurrentAttendee(
      currentAttendeeInstance.attendeeId,
      currentTicket
    );
    if (!success) return;

    setActiveAttendeeTab((prev) => ({ ...prev, [ticketIndex]: attendeeIndex }));
  };

  const handleInputChange = (
    attendeeId,
    fieldId,
    value,
    optionIndex = null
  ) => {
    console.log("handleInputChange:", {
      attendeeId,
      fieldId,
      value,
      optionIndex,
    });
    setAllFormsData((prev) => {
      const attendeeData = prev[attendeeId] || {};
      let newFormData = { ...attendeeData.formData };

      if (
        attendeeData.formDetails?.find((f) => f.id === fieldId)?.type ===
        "checkbox"
      ) {
        const currentValues = [...(newFormData[fieldId] || [])];
        currentValues[optionIndex] = value;
        newFormData = { ...newFormData, [fieldId]: currentValues };
      } else {
        newFormData = { ...newFormData, [fieldId]: value };
      }

      return {
        ...prev,
        [attendeeId]: { ...attendeeData, formData: newFormData },
      };
    });

    const attendeeData = allFormsData[attendeeId];
    if (attendeeData) {
      const field = attendeeData.formDetails?.find((f) => f.id === fieldId);
      if (field) {
        const error =
          field.type === "checkbox"
            ? validateCheckbox(field, attendeeData.formData[fieldId])
            : field.type === "radio" || field.type === "select"
            ? validateRadio(field, value)
            : validateField(field, value);
        const errorKey = `${attendeeId}-${fieldId}`;
        setErrors((prev) => ({ ...prev, [errorKey]: error || "" }));
      }
    }
  };
  const clearAutoFilledFields = useRef((attendeeId) => {
    const autoFillKeys = ["first_name", "last_name", "email_address"];

    setAllFormsData((prev) => {
      const attendee = prev[attendeeId];
      if (!attendee?.formDetails) return prev;

      const newFormData = { ...attendee.formData };

      attendee.formDetails.forEach((f) => {
        if (autoFillKeys.includes(f.name)) {
          newFormData[f.id] = "";
        }
      });

      return {
        ...prev,
        [attendeeId]: { ...attendee, formData: newFormData },
      };
    });

    setErrors((prev) => {
      const cleaned = { ...prev };
      Object.keys(cleaned).forEach((k) => {
        if (
          k.startsWith(`${attendeeId}-`) &&
          autoFillKeys.some((n) => k.includes(n))
        ) {
          delete cleaned[k];
        }
      });
      return cleaned;
    });
  }).current;
  const handleFileChange = async (attendeeId, fieldId, event) => {
    const file = event.target.files[0];
    console.log("handleFileChange:", { attendeeId, fieldId, file });
    if (!file) {
      setAllFormsData((prev) => ({
        ...prev,
        [attendeeId]: {
          ...prev[attendeeId],
          formData: {
            ...prev[attendeeId].formData,
            [fieldId]: null,
          },
        },
      }));
      setErrors((prev) => ({
        ...prev,
        [`${attendeeId}-${fieldId}`]: "No file selected",
      }));
      return;
    }

    const uploadKey = `${attendeeId}-${fieldId}`;
    setIsUploading((prev) => ({ ...prev, [uploadKey]: true }));
    setErrors((prev) => ({ ...prev, [uploadKey]: "Uploading..." }));

    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await uploadFilesAWS(formData);
      console.log(
        "uploadFilesAWS Response:",
        JSON.stringify(response.data, null, 2)
      );

      const fileUrl = response.data.uploadedUrls.file[0];
      if (fileUrl) {
        setAllFormsData((prev) => ({
          ...prev,
          [attendeeId]: {
            ...prev[attendeeId],
            formData: {
              ...prev[attendeeId].formData,
              [fieldId]: fileUrl,
            },
          },
        }));
        const field = allFormsData[attendeeId]?.formDetails?.find(
          (f) => f.id === fieldId
        );
        if (field) {
          const error = validateField(field, fileUrl);
          setErrors((prev) => ({
            ...prev,
            [uploadKey]: error || "",
          }));
        }
      } else {
        setErrors((prev) => ({
          ...prev,
          [uploadKey]: "File upload failed: No URL returned",
        }));
      }
    } catch (error) {
      console.log("File upload error:", error);
      setErrors((prev) => ({
        ...prev,
        [uploadKey]: error.response?.data?.message || "Failed to upload file",
      }));
    } finally {
      setIsUploading((prev) => ({ ...prev, [uploadKey]: false }));
    }
  };

  const toggleAddon = (attendeeId, addonId, variant = null) => {
    console.log("toggleAddon:", { attendeeId, addonId, variant });
    setAllFormsData((prev) => {
      const attendeeData = prev[attendeeId] || {};
      const updatedAddons =
        attendeeData.addons?.map((addon) => {
          if (addon.id === addonId) {
            if (addon.addons_type === "variant" && variant) {
              const normalizedVariant = {
                variant_name: variant.variant_name,
                variant_price: variant.variant_price,
                quantity: 1,
              };
              const existingIndex = addon.selectedVariants.findIndex(
                (sv) => sv.variant_name === normalizedVariant.variant_name
              );
              let newSelectedVariants = [...addon.selectedVariants];
              if (existingIndex >= 0) {
                newSelectedVariants.splice(existingIndex, 1);
              } else {
                newSelectedVariants.push(normalizedVariant);
              }
              return {
                ...addon,
                isAdded: newSelectedVariants.length > 0,
                selectedVariants: newSelectedVariants,
              };
            } else if (addon.addons_type === "single") {
              if (addon.isAdded) {
                return {
                  ...addon,
                  isAdded: false,
                  quantity: 0,
                };
              } else {
                return {
                  ...addon,
                  isAdded: true,
                  quantity: 1,
                };
              }
            }
          }
          return addon;
        }) || [];

      return {
        ...prev,
        [attendeeId]: { ...attendeeData, addons: updatedAddons },
      };
    });
  };

  const updateAddonQuantity = (attendeeId, addonId, change, variantName) => {
    console.log("updateAddonQuantity:", {
      attendeeId,
      addonId,
      change,
      variantName,
    });
    setAllFormsData((prev) => {
      const attendeeData = prev[attendeeId] || {};
      const updatedAddons =
        attendeeData.addons?.map((addon) => {
          if (addon.id === addonId) {
            if (addon.addons_type === "variant") {
              const newSelectedVariants = addon.selectedVariants
                .map((sv) => {
                  if (sv.variant_name === variantName) {
                    const maxQuantity = addon.maxQuantity || 1;
                    let newQuantity = Math.max(
                      addon.isMandatory ? 1 : 0,
                      Math.min(maxQuantity, (sv.quantity || 0) + change)
                    );
                    return { ...sv, quantity: newQuantity };
                  }
                  return sv;
                })
                .filter((sv) => sv.quantity > 0);
              return {
                ...addon,
                selectedVariants: newSelectedVariants,
                isAdded: newSelectedVariants.length > 0,
              };
            } else if (addon.addons_type === "single") {
              const maxQuantity = addon.maxQuantity || 1;
              const minQuantity = addon.isMandatory ? 1 : 0;
              let newQuantity = Math.max(
                minQuantity,
                Math.min(maxQuantity, (addon.quantity || 0) + change)
              );
              return {
                ...addon,
                quantity: newQuantity,
                isAdded: newQuantity > 0,
              };
            }
          }
          return addon;
        }) || [];

      return {
        ...prev,
        [attendeeId]: { ...attendeeData, addons: updatedAddons },
      };
    });
  };

  const calculateAttendeePricing = (attendeeId, ticket) => {
    const attendeeData = allFormsData[attendeeId] || {};
    let subtotal = 0;
    let tax_total = 0;

    const base = Number(ticket.price) || 0;
    const tax_options =
      ticket.instanceType === "main"
        ? typeof ticket.tax_options === "string"
          ? JSON.parse(ticket.tax_options)
          : ticket.tax_options || []
        : ticket.guest_details?.tax_options
        ? typeof ticket.guest_details.tax_options === "string"
          ? JSON.parse(ticket.guest_details.tax_options)
          : ticket.guest_details.tax_options || []
        : [];
    const relevantTaxes = stateIsSame
      ? tax_options.filter((t) => ["CGST", "SGST"].includes(t.tax_name))
      : tax_options.filter((t) => t.tax_name === "IGST");
    const rate =
      relevantTaxes.reduce(
        (sum, t) => sum + (Number.parseFloat(t.tax_percentage) || 0),
        0
      ) / 100;
    const tax_type =
      ticket.instanceType === "main"
        ? ticket.tax_type || "No Tax"
        : ticket.guest_details?.tax_type || "No Tax";
    let item_net = 0;
    let item_tax = 0;

    if (ticket.category === "Free" || tax_type === "No Tax") {
      item_net = base;
      item_tax = 0;
    } else if (tax_type === "Including Tax") {
      const item_total = base;
      const denom = 1 + rate;
      item_net = denom > 1 ? item_total / denom : item_total;
      item_tax = item_total - item_net;
    } else if (tax_type === "Excluding Tax") {
      item_net = base;
      item_tax = item_net * rate;
    }

    subtotal += item_net;
    tax_total += item_tax;

    if (attendeeData.addons) {
      attendeeData.addons.forEach((addon) => {
        if (addon.isAdded && addon.addon_status === "onsale") {
          const a_base =
            addon.addons_type === "variant"
              ? addon.selectedVariants.reduce((sum, variant) => {
                  return (
                    sum +
                    (Number.parseFloat(variant.variant_price) || 0) *
                      variant.quantity
                  );
                }, 0)
              : Number.parseFloat(addon.price || 0);
          const a_qty = addon.addons_type === "variant" ? 1 : addon.quantity;
          const a_tax_options = addon.tax_options || [];
          const a_relevantTaxes = stateIsSame
            ? a_tax_options.filter((t) => ["CGST", "SGST"].includes(t.tax_name))
            : a_tax_options.filter((t) => t.tax_name === "IGST");
          const a_rate =
            a_relevantTaxes.reduce(
              (sum, t) => sum + (Number.parseFloat(t.tax_percentage) || 0),
              0
            ) / 100;
          const a_tax_type = addon.tax_type || "No Tax";
          let a_net = 0;
          let a_tax = 0;

          if (a_tax_type === "No Tax") {
            a_net = a_base * a_qty;
            a_tax = 0;
          } else if (a_tax_type === "Including Tax") {
            const a_total = a_base * a_qty;
            const denom = 1 + a_rate;
            a_net = denom > 1 ? a_total / denom : a_total;
            a_tax = a_total - a_net;
          } else if (a_tax_type === "Excluding Tax") {
            a_net = a_base * a_qty;
            a_tax = a_net * a_rate;
          }

          subtotal += a_net;
          tax_total += a_tax;
        }
      });
    }

    const tax = Math.round(tax_total);
    const total = Math.round(subtotal + tax_total);

    return { subtotal: Math.round(subtotal), tax, total };
  };

  const calculateTotalPricing = () => {
    let subtotal = 0;
    let tax_total = 0;

    expandedTickets.forEach((ticket) => {
      ticket.attendeeInstances.forEach((attendeeInstance) => {
        const pricing = calculateAttendeePricing(
          attendeeInstance.attendeeId,
          ticket
        );
        subtotal += pricing.subtotal;
        tax_total += pricing.tax;
      });
    });

    const tax = Math.round(tax_total);
    const total = Math.round(subtotal + tax_total);

    return { subtotal, tax, total, taxName };
  };

  // const calculateTotalPricing = () => {
  //   let subtotal = 0;
  //   let tax_total = 0;

  //   expandedTickets.forEach((ticket) => {
  //     ticket.attendeeInstances.forEach((attendeeInstance) => {
  //       const pricing = calculateAttendeePricing(
  //         attendeeInstance.attendeeId,
  //         ticket
  //       );
  //       subtotal += pricing.subtotal;
  //       tax_total += pricing.tax;
  //     });
  //   });

  //   const tax = Math.round(tax_total * 100) / 100;
  //   const total = Math.round((subtotal + tax_total) * 100) / 100;

  //   return { subtotal, tax, total, taxName };
  // };
  const uploadAndSet = async (attendeeId, fieldId, formData) => {
    const uploadKey = `${attendeeId}-${fieldId}`;
    setIsUploading((prev) => ({ ...prev, [uploadKey]: true }));
    setErrors((prev) => ({ ...prev, [uploadKey]: "Uploading..." }));

    try {
      const response = await uploadFilesAWS(formData);
      const url = response?.data?.uploadedUrls?.file?.[0];
      if (url) {
        setAllFormsData((prev) => ({
          ...prev,
          [attendeeId]: {
            ...prev[attendeeId],
            formData: { ...prev[attendeeId].formData, [fieldId]: url },
          },
        }));
        const field = allFormsData[attendeeId]?.formDetails?.find(
          (f) => f.id === fieldId
        );
        const err = field ? validateField(field, url) : null;
        setErrors((prev) => ({ ...prev, [uploadKey]: err || "" }));
      } else {
        setErrors((prev) => ({
          ...prev,
          [uploadKey]: "Upload failed – no URL",
        }));
      }
      return response?.data;
    } catch (e) {
      setErrors((prev) => ({
        ...prev,
        [uploadKey]: e.response?.data?.message || "Upload error",
      }));
    } finally {
      setIsUploading((prev) => ({ ...prev, [uploadKey]: false }));
    }
  };
  const validateAllForms = () => {
    console.log("Validating all forms");
    const newErrors = {};
    let isValid = true;

    expandedTickets.forEach((ticket) => {
      ticket.attendeeInstances.forEach((attendeeInstance) => {
        const attendeeData = allFormsData[attendeeInstance.attendeeId];
        if (!attendeeData) return;

        if (Array.isArray(attendeeData.formDetails)) {
          attendeeData.formDetails.forEach((field) => {
            const value = attendeeData.formData[field.id];
            let error = null;
            if (field.type === "checkbox") {
              error = validateCheckbox(field, value);
            } else if (field.type === "radio" || field.type === "select") {
              error = validateRadio(field, value);
            } else {
              error = validateField(field, value);
            }
            if (error) {
              const errorKey = `${attendeeInstance.attendeeId}-${field.id}`;
              newErrors[errorKey] = error;
              isValid = false;
            }
          });
        }

        if (attendeeData.type === "guest" && !attendeeData.selectedMain) {
          const errorKey = `${attendeeInstance.attendeeId}-selectedMain`;
          newErrors[errorKey] = "Please select the accompanying attendee";
          isValid = false;
        }

        if (!validateAddons(attendeeInstance.attendeeId)) {
          const errorKey = `${attendeeInstance.attendeeId}-addons`;
          newErrors[errorKey] = "Please select all mandatory add-ons";
          isValid = false;
        }
      });
    });

    const buyerData = allFormsData["buyer-form"];
    if (buyerData && Array.isArray(buyerData.formDetails)) {
      buyerData.formDetails.forEach((field) => {
        const value = buyerData.formData[field.id];
        let error = null;
        if (field.type === "checkbox") {
          error = validateCheckbox(field, value);
        } else if (field.type === "radio") {
          error = validateRadio(field, value);
        } else {
          error = validateField(field, value);
        }
        if (error) {
          const errorKey = `buyer-form-${field.id}`;
          newErrors[errorKey] = error;
          isValid = false;
        }
      });
    }

    setErrors(newErrors);
    console.log("Validation result:", { isValid, errors: newErrors });
    return isValid;
  };

  const handleProceed = async () => {
    console.log("handleProceed called");
    if (!validateAllForms()) {
      console.log("Validation failed, cannot proceed");
      setErrorMessage(
        "Please fill all required fields and select mandatory add-ons."
      );
      return;
    }

    setIsSubmitting(true);
    setErrorMessage("");
    const startTime = Date.now();

    let allSaved = true;

    try {
      for (const ticket of expandedTickets) {
        for (const attendeeInstance of ticket.attendeeInstances) {
          const attendeeId = attendeeInstance.attendeeId;
          if (!savedAttendees[attendeeId]) {
            console.log(`Saving attendee ${attendeeId}`);
            const success = await saveCurrentAttendee(attendeeId, ticket);
            if (!success) {
              allSaved = false;
              break;
            }
          }
        }
        if (!allSaved) break;
      }

      if (allSaved) {
        const ticketGroups = {};
        const attendeeIdToIndex = {};

        expandedTickets.forEach((ticket) => {
          const originalTicketId = ticket.originalTicketId;

          if (ticket.instanceType === "main") {
            if (!ticketGroups[originalTicketId]) {
              ticketGroups[originalTicketId] = {
                ticket_id: originalTicketId,
                attendee_data: [],
              };
            }

            ticket.attendeeInstances.forEach((attendeeInstance) => {
              const attendeeData = allFormsData[attendeeInstance.attendeeId];
              if (!attendeeData) return;

              const add_ons = attendeeData.addons
                .filter((addon) => addon.isAdded)
                .map((addon) => ({
                  ...addon,
                  variant: addon.selectedVariant
                    ? addon.selectedVariant.name
                    : null,
                }));

              const pricing = calculateAttendeePricing(
                attendeeInstance.attendeeId,
                ticket
              );

              const mainAttendeeEntry = {
                form_id: ticket.selected_form || 1,
                form_data: [
                  {
                    custom_fields: Array.isArray(attendeeData.formDetails)
                      ? attendeeData.formDetails.map((field) => {
                          const fieldValue = attendeeData.formData[field.id];
                          if (field.type === "checkbox") {
                            return {
                              id: field.id,
                              type: field.type,
                              label: field.label,
                              value: fieldValue
                                ? fieldValue
                                    .filter((v) => v)
                                    .map((_, i) => field.options[i])
                                    .join(", ")
                                : "",
                            };
                          } else if (
                            field.type === "radio" ||
                            field.type === "select"
                          ) {
                            return {
                              id: field.id,
                              type: field.type,
                              label: field.label,
                              value: fieldValue || "",
                            };
                          }
                          return {
                            id: field.id,
                            type: field.type,
                            label: field.label,
                            value: fieldValue || "",
                          };
                        })
                      : [],
                    add_ons,
                  },
                ],
                guest_data: [],
                first_name:
                  attendeeData.formData[
                    Object.keys(attendeeData.formData).find((key) =>
                      key.includes("firstname")
                    )
                  ] || "",
                last_name:
                  attendeeData.formData[
                    Object.keys(attendeeData.formData).find((key) =>
                      key.includes("lastname")
                    )
                  ] || "",
                email:
                  attendeeData.formData[
                    Object.keys(attendeeData.formData).find((key) =>
                      key.includes("email")
                    )
                  ] || "",
                add_ons_data: add_ons,
                actual_payment_amount: pricing.total.toString(),
                add_on_amount: attendeeData.addons
                  .filter((addon) => addon.isAdded)
                  .reduce((sum, addon) => {
                    const a_base =
                      addon.addons_type === "variant" && addon.selectedVariant
                        ? Number.parseFloat(addon.selectedVariant.price) || 0
                        : Number.parseFloat(addon.price || 0);
                    const a_qty = addon.quantity;
                    const a_tax_options = addon.tax_options || [];
                    const a_rate =
                      a_tax_options.reduce(
                        (sum, t) =>
                          sum + (Number.parseFloat(t.tax_percentage) || 0),
                        0
                      ) / 100;
                    const a_tax_type = addon.tax_type || "No Tax";
                    let a_total = a_base * a_qty;
                    if (a_tax_type === "Excluding Tax") {
                      a_total += a_base * a_qty * a_rate;
                    }
                    return sum + Math.round(a_total * 100) / 100;
                  }, 0)
                  .toString(),
                ticket_amount: ticket.price.toString(),
                ticket_taxname: taxName,
                ticket_taxpercentage: ticket.tax_options
                  ? ticket.tax_options.reduce(
                      (sum, t) =>
                        sum + (Number.parseFloat(t.tax_percentage) || 0),
                      0
                    )
                  : 0,
                ticket_amount_with_tax: (
                  ticket.price *
                  (1 +
                    (ticket.tax_options
                      ? ticket.tax_options.reduce(
                          (sum, t) =>
                            sum + (Number.parseFloat(t.tax_percentage) || 0),
                          0
                        ) / 100
                      : 0))
                ).toString(),
                instance_type: ticket.instanceType,
                instance_index: attendeeInstance.attendeeIndex,
              };

              const mainIndex =
                ticketGroups[originalTicketId].attendee_data.push(
                  mainAttendeeEntry
                ) - 1;
              attendeeIdToIndex[attendeeInstance.attendeeId] = mainIndex;
            });
          }
        });

        expandedTickets.forEach((ticket) => {
          const originalTicketId = ticket.originalTicketId;

          if (ticket.instanceType === "guest") {
            ticket.attendeeInstances.forEach((attendeeInstance) => {
              const attendeeData = allFormsData[attendeeInstance.attendeeId];
              if (!attendeeData) return;

              const add_ons = attendeeData.addons
                ? attendeeData.addons
                    .filter((addon) => addon.isAdded)
                    .map((addon) => ({
                      ...addon,
                      variant: addon.selectedVariant
                        ? addon.selectedVariant.name
                        : null,
                    }))
                : [];

              const selectedMain = attendeeData.selectedMain;
              const mainAttendee = mainAttendees.find(
                (m) => m.value === selectedMain
              );
              const mainAttendeeId = mainAttendee ? mainAttendee.backendId : "";

              const guestEntry = {
                ticket_id: originalTicketId,
                custom_fields: [
                  ...(Array.isArray(attendeeData.formDetails)
                    ? attendeeData.formDetails.map((field) => {
                        const fieldValue = attendeeData.formData[field.id];
                        if (field.type === "checkbox") {
                          return {
                            id: field.id,
                            type: field.type,
                            label: field.label,
                            value: fieldValue
                              ? fieldValue
                                  .filter((v) => v)
                                  .map((_, i) => field.options[i])
                                  .join(", ")
                              : "",
                          };
                        } else if (
                          field.type === "radio" ||
                          field.type === "select"
                        ) {
                          return {
                            id: field.id,
                            type: field.type,
                            label: field.label,
                            value: fieldValue || "",
                          };
                        }
                        return {
                          id: field.id,
                          type: field.type,
                          label: field.label,
                          value: fieldValue || "",
                          name:
                            field.name ||
                            field.label.toLowerCase().replace(/ /g, "_"),
                        };
                      })
                    : []),
                  {
                    id: "main_attendee_id",
                    type: "text",
                    label: "Main Attendee ID",
                    name: "main_attendee_id",
                    value: mainAttendeeId ? mainAttendeeId.toString() : "",
                  },
                ],
                add_ons,
              };

              const mainIndex = attendeeIdToIndex[selectedMain];
              if (
                mainIndex !== undefined &&
                ticketGroups[originalTicketId] &&
                ticketGroups[originalTicketId].attendee_data[mainIndex]
              ) {
                ticketGroups[originalTicketId].attendee_data[
                  mainIndex
                ].guest_data.push(guestEntry);
              } else {
                console.log(
                  `No main attendee found for guest ${attendeeInstance.attendeeId} with selectedMain ${selectedMain}`
                );
              }
            });
          }
        });

        const buyerData = allFormsData["buyer-form"];
        const buyerFormEntry = {
          form_id: eventData?.settings?.buyer_form || 29,
          form_data: [
            {
              custom_fields: Array.isArray(buyerData.formDetails)
                ? buyerData.formDetails.map((field) => {
                    const fieldValue = buyerData.formData[field.id];
                    if (field.type === "checkbox") {
                      return {
                        id: field.id,
                        type: field.type,
                        label: field.label,
                        value: fieldValue
                          ? fieldValue
                              .filter((v) => v)
                              .map((_, i) => field.options[i])
                              .join(", ")
                          : "",
                      };
                    } else if (field.type === "radio") {
                      return {
                        id: field.id,
                        type: field.type,
                        label: field.label,
                        value: fieldValue || "",
                      };
                    }
                    return {
                      id: field.id,
                      type: field.type,
                      label: field.label,
                      value: fieldValue || "",
                      name:
                        field.name ||
                        field.label.toLowerCase().replace(/ /g, "_"),
                    };
                  })
                : [],
            },
          ],
          first_name:
            buyerData.formData[
              Object.keys(buyerData.formData).find((key) =>
                key.includes("firstname")
              )
            ] || "",
          last_name:
            buyerData.formData[
              Object.keys(buyerData.formData).find((key) =>
                key.includes("lastname")
              )
            ] || "",
          email:
            buyerData.formData[
              Object.keys(buyerData.formData).find((key) =>
                key.includes("email")
              )
            ] || "",
        };

        const formattedData = {
          tickets: Object.values(ticketGroups),
          buyer: buyerFormEntry,
        };

        const totalPricing = calculateTotalPricing();
        console.log(
          "Proceeding with formatted data:",
          JSON.stringify(formattedData, null, 2)
        );
        onProceed(formattedData, "order-summary", totalPricing);
      }
    } catch (err) {
      console.log("Error during proceed:", err);
      setErrorMessage("An error occurred while finalizing details.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const currentTicket = expandedTickets[activeTicketTab];
  const currentAttendeeIndex = activeAttendeeTab[activeTicketTab] || 0;
  const currentAttendeeInstance =
    currentTicket?.attendeeInstances[currentAttendeeIndex];
  const currentPricing = currentAttendeeInstance
    ? calculateAttendeePricing(
        currentAttendeeInstance.attendeeId,
        currentTicket
      )
    : { subtotal: 0, tax: 0, total: 0 };
  const {
    subtotal: totalSubtotal,
    tax: totalTax,
    total: grandTotal,
    taxName: totalTaxName,
  } = calculateTotalPricing();

  return (
    <>
      <ToastMessage />
      <div className="sticky-event-header">
        <div className="sticky-event-content">
          <h1 className="sticky-event-title">Attendee Details</h1>
          <div className="sticky-event-details">
            <div className="total-item">
              <span>Fill details for each attendee</span>
            </div>
          </div>
        </div>
      </div>

      <div className="card-content">
        {isSubmitting && (
          <div className="loader-container">
            <div className="spinner"></div>
            <p>Loading </p>
          </div>
        )}
        {errorMessage && (
          <div
            className="error-message"
            style={{
              color: "#ef4444",
              marginBottom: "16px",
              fontSize: "14px",
              backgroundColor: "#fef2f2",
              padding: "10px",
              borderRadius: "4px",
            }}
          >
            {errorMessage}
          </div>
        )}

        {buyerFormDetails.length > 0 && (
          <div className="buyer-form-section" style={{ marginBottom: "24px" }}>
            <h3
              style={{
                fontSize: "18px",
                fontWeight: "600",
                marginBottom: "16px",
                color: "#1e293b",
              }}
            ></h3>
            {allFormsData["buyer-form"]?.formDetails?.map((field) => (
              <div
                key={field.id}
                className="form-group"
                style={{ marginBottom: "16px" }}
              >
                <label
                  htmlFor={`buyer-form-${field.id}`}
                  className="form-label"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#374151",
                    marginBottom: "8px",
                  }}
                >
                  {field.label}
                  {field.required && (
                    <span
                      style={{
                        color: "#ef4444",
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      *
                    </span>
                  )}
                </label>

                {field.type === "checkbox" && (
                  <div className="checkbox-group">
                    {field.options?.map((option, index) => (
                      <div
                        key={`${field.id}-${index}`}
                        style={{ marginBottom: "8px" }}
                      >
                        <input
                          type="checkbox"
                          id={`buyer-form-${field.id}-${index}`}
                          className="form-input"
                          checked={
                            allFormsData["buyer-form"]?.formData?.[field.id]?.[
                              index
                            ] || false
                          }
                          onChange={(e) =>
                            handleInputChange(
                              "buyer-form",
                              field.id,
                              e.target.checked,
                              index
                            )
                          }
                          style={{
                            marginRight: "8px",
                            verticalAlign: "middle",
                          }}
                        />
                        <label
                          htmlFor={`buyer-form-${field.id}-${index}`}
                          style={{
                            display: "inline",
                            verticalAlign: "middle",
                            fontSize: "16px",
                            color: "#374151",
                          }}
                        >
                          {option}
                        </label>
                      </div>
                    ))}
                  </div>
                )}

                {field.type === "radio" && (
                  <div className="radio-group">
                    {field.options?.map((option, index) => (
                      <div
                        key={`${field.id}-${index}`}
                        style={{ marginBottom: "8px" }}
                      >
                        <input
                          type="radio"
                          id={`buyer-form-${field.id}-${index}`}
                          name={`buyer-form-${field.id}`}
                          className="form-input"
                          value={option}
                          checked={
                            allFormsData["buyer-form"]?.formData?.[field.id] ===
                            option
                          }
                          onChange={(e) =>
                            handleInputChange(
                              "buyer-form",
                              field.id,
                              e.target.value
                            )
                          }
                          style={{
                            marginRight: "8px",
                            verticalAlign: "middle",
                          }}
                        />
                        <label
                          htmlFor={`buyer-form-${field.id}-${index}`}
                          style={{
                            display: "inline",
                            verticalAlign: "middle",
                            fontSize: "16px",
                            color: "#374151",
                          }}
                        >
                          {option}
                        </label>
                      </div>
                    ))}
                  </div>
                )}

                {field.type === "select" && (
                  <select
                    id={`buyer-form-${field.id}`}
                    className="form-input"
                    style={{
                      width: "100%",
                      padding: "12px 16px",
                      border: errors[`buyer-form-${field.id}`]
                        ? "2px solid #ef4444"
                        : "2px solid #e5e7eb",
                      borderRadius: "8px",
                      fontSize: "16px",
                      transition: "all 0.2s ease",
                      outline: "none",
                      backgroundColor: errors[`buyer-form-${field.id}`]
                        ? "#fef2f2"
                        : "#fafafa",
                    }}
                    value={
                      allFormsData["buyer-form"]?.formData?.[field.id] || ""
                    }
                    onChange={(e) =>
                      handleInputChange("buyer-form", field.id, e.target.value)
                    }
                  >
                    <option value="">Select an option</option>
                    {field.options?.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                )}
                {field.type === "file" && (
                  <FileUploadField
                    field={field}
                    attendeeId="buyer-form"
                    value={
                      allFormsData["buyer-form"]?.formData?.[field.id] || null
                    }
                    isUploading={isUploading[`buyer-form-${field.id}`] || false}
                    error={errors[`buyer-form-${field.id}`]}
                    onFileChange={(formData) =>
                      uploadAndSet("buyer-form", field.id, formData)
                    }
                    onUploadStart={() =>
                      setIsUploading((prev) => ({
                        ...prev,
                        [`buyer-form-${field.id}`]: true,
                      }))
                    }
                    onUploadEnd={() =>
                      setIsUploading((prev) => ({
                        ...prev,
                        [`buyer-form-${field.id}`]: false,
                      }))
                    }
                    onFileRemove={() => {
                      setAllFormsData((prev) => ({
                        ...prev,
                        "buyer-form": {
                          ...prev["buyer-form"],
                          formData: {
                            ...prev["buyer-form"].formData,
                            [field.id]: null,
                          },
                        },
                      }));
                      setErrors((prev) => ({
                        ...prev,
                        [`buyer-form-${field.id}`]: "",
                      }));
                    }}
                  />
                )}

                {field.type !== "checkbox" &&
                  field.type !== "radio" &&
                  field.type !== "file" &&
                  field.type !== "select" && (
                    <div style={{ marginBottom: "16px" }}>
                      {/* === MEMBERSHIP FIELD === */}
                      {field.name === "amasimembership_number" ? (
                        <div className="membership-input-wrapper">
                          {/* LABEL: Only here */}
                          {/* <label
        htmlFor={`${currentAttendeeInstance.attendeeId}-${field.id}`}
        style={{
          display: "block",
          marginBottom: "6px",
          fontSize: "14px",
          fontWeight: "500",
          color: "#374151",
        }}
      >
        {field.label} {field.required && <span style={{ color: "#ef4444" }}>*</span>}
      </label> */}

                          <div style={{ position: "relative" }}>
                            <input
                              type={field.type}
                              id={`${currentAttendeeInstance.attendeeId}-${field.id}`}
                              className="form-input"
                              placeholder={
                                field.placeholder ||
                                "Enter your Mobile or Email"
                              }
                              value={
                                allFormsData[currentAttendeeInstance.attendeeId]
                                  ?.formData?.[field.id] || ""
                              }
                              onChange={(e) => {
                                const value = e.target.value;
                                const attendeeId =
                                  currentAttendeeInstance.attendeeId;

                                handleInputChange(attendeeId, field.id, value);

                                setErrors((prev) => {
                                  const key = `${attendeeId}-${field.id}`;
                                  if (prev[key]) {
                                    const { [key]: _, ...rest } = prev;
                                    return rest;
                                  }
                                  return prev;
                                });

                                // if (value.trim().length >= 3) {
                                //   if (membershipTimeoutRef.current) clearTimeout(membershipTimeoutRef.current);
                                //   membershipTimeoutRef.current = setTimeout(() => {
                                //     fetchMemberDetails(attendeeId, value);
                                //   }, 500);
                                // } else {
                                //   setVerifiedMemberships((prev) => {
                                //     const { [attendeeId]: _, ...rest } = prev;
                                //     return rest;
                                //   });
                                // }
                              }}
                              style={{
                                width: "100%",
                                padding: "12px 44px 12px 16px",
                                borderRadius: "8px",
                                border: `2px solid ${
                                  errors[
                                    `${currentAttendeeInstance.attendeeId}-${field.id}`
                                  ]
                                    ? "#ef4444"
                                    : verifiedMemberships[
                                        currentAttendeeInstance.attendeeId
                                      ]
                                    ? "#10b981"
                                    : "#d1d5db"
                                }`,
                                fontSize: "16px",
                                outline: "none",
                                backgroundColor: errors[
                                  `${currentAttendeeInstance.attendeeId}-${field.id}`
                                ]
                                  ? "#fef2f2"
                                  : "#ffffff",
                                transition: "all 0.2s ease",
                                boxShadow: verifiedMemberships[
                                  currentAttendeeInstance.attendeeId
                                ]
                                  ? "0 0 0 1px #10b981"
                                  : "none",
                              }}
                            />

                            <button
                              type="button"
                              onClick={() => {
                                const val =
                                  allFormsData[
                                    currentAttendeeInstance.attendeeId
                                  ]?.formData?.[field.id] || "";
                                // if (val.trim().length >= 3)
                                //   fetchMemberDetails(
                                //     currentAttendeeInstance.attendeeId,
                                //     val
                                //   );
                              }}
                              disabled={
                                isSubmitting ||
                                !allFormsData[
                                  currentAttendeeInstance.attendeeId
                                ]?.formData?.[field.id]?.trim() ||
                                allFormsData[
                                  currentAttendeeInstance.attendeeId
                                ]?.formData?.[field.id].trim().length < 3
                              }
                              style={{
                                position: "absolute",
                                right: "12px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                                opacity:
                                  allFormsData[
                                    currentAttendeeInstance.attendeeId
                                  ]?.formData?.[field.id]?.trim().length >= 3
                                    ? 1
                                    : 0.5,
                              }}
                              title="Verify membership (min 3 characters)"
                            >
                              {verifiedMemberships[
                                currentAttendeeInstance.attendeeId
                              ] ? (
                                <span
                                  style={{
                                    color: "#10b981",
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Checkmark
                                </span>
                              ) : isUploading[
                                  currentAttendeeInstance.attendeeId
                                ] ? (
                                <span style={{ color: "#3b82f6" }}>
                                  Loading...
                                </span>
                              ) : (
                                // <FaSearch style={{ color: "#6b7280", fontSize: "18px" }} />
                                <button
                                  style={{
                                    padding: "8px 16px",
                                    backgroundColor: "#10b981",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "8px",

                                    position: "relative",
                                  }}
                                >
                                  Verify
                                </button>
                              )}
                            </button>
                          </div>

                          {/* Error */}
                          {errors[
                            `${currentAttendeeInstance.attendeeId}-${field.id}`
                          ] && (
                            <p
                              style={{
                                color: "#ef4444",
                                fontSize: "13px",
                                margin: "6px 0 0",
                              }}
                            >
                              {
                                errors[
                                  `${currentAttendeeInstance.attendeeId}-${field.id}`
                                ]
                              }
                            </p>
                          )}

                          {/* Success */}
                          {verifiedMemberships[
                            currentAttendeeInstance.attendeeId
                          ] &&
                            !errors[
                              `${currentAttendeeInstance.attendeeId}-${field.id}`
                            ] && (
                              <p
                                style={{
                                  color: "#10b981",
                                  fontSize: "13px",
                                  margin: "6px 0 0",
                                }}
                              >
                                {membershipNumber} Membership verified
                                successfully
                              </p>
                            )}
                        </div>
                      ) : (
                        /* === ALL OTHER TEXT FIELDS === */
                        <div>
                          {/* LABEL: Only here */}
                          <label
                            htmlFor={`${currentAttendeeInstance.attendeeId}-${field.id}`}
                            style={{
                              display: "block",
                              marginBottom: "6px",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                            }}
                          >
                            {field.label}{" "}
                            {field.required && (
                              <span style={{ color: "#ef4444" }}>*</span>
                            )}
                          </label>

                          <input
                            type={field.type}
                            id={`${currentAttendeeInstance.attendeeId}-${field.id}`}
                            className="form-input"
                            placeholder={field.placeholder}
                            value={
                              allFormsData[currentAttendeeInstance.attendeeId]
                                ?.formData?.[field.id] || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                currentAttendeeInstance.attendeeId,
                                field.id,
                                e.target.value
                              )
                            }
                            style={{
                              width: "100%",
                              padding: "12px 16px",
                              borderRadius: "8px",
                              border: errors[
                                `${currentAttendeeInstance.attendeeId}-${field.id}`
                              ]
                                ? "2px solid #ef4444"
                                : "2px solid #e5e7eb",
                              fontSize: "16px",
                              outline: "none",
                              backgroundColor: errors[
                                `${currentAttendeeInstance.attendeeId}-${field.id}`
                              ]
                                ? "#fef2f2"
                                : "#fafafa",
                              transition: "all 0.2s ease",
                            }}
                          />

                          {/* Error */}
                          {errors[
                            `${currentAttendeeInstance.attendeeId}-${field.id}`
                          ] && (
                            <p
                              style={{
                                color: "#ef4444",
                                fontSize: "13px",
                                margin: "6px 0 0",
                              }}
                            >
                              {
                                errors[
                                  `${currentAttendeeInstance.attendeeId}-${field.id}`
                                ]
                              }
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  )}

                {errors[`buyer-form-${field.id}`] &&
                  !isUploading[`buyer-form-${field.id}`] && (
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#ef4444",
                        marginTop: "4px",
                        display: "block",
                        fontWeight: "500",
                      }}
                    >
                      {errors[`buyer-form-${field.id}`]}
                    </span>
                  )}
              </div>
            ))}
          </div>
        )}

        <div className="ticket-tabs" style={{ marginBottom: "24px" }}>
          <div
            style={{
              display: "flex",
              gap: "8px",
              flexWrap: "wrap",
              marginTop: "24px",
            }}
          >
            {expandedTickets.map((ticket, index) => {
              const isComplete = isTicketComplete(index);
              const canNavigate =
                index === 0 ||
                expandedTickets
                  .slice(0, index)
                  .every((_, i) => isTicketComplete(i));
              const isGuest = ticket.instanceType === "guest";

              return (
                <button
                  key={ticket.instanceId}
                  onClick={() => handleTicketTabClick(index)}
                  disabled={!canNavigate}
                  className={`ticket-btn-guest ${
                    activeTicketTab === index ? "active" : ""
                  } ${isComplete ? "complete" : ""} ${isGuest ? "guest" : ""} ${
                    !canNavigate ? "disabled" : ""
                  }`}
                >
                  {isGuest && (
                    <span className="guest-icon">
                      <i className="fa fa-users"></i>
                    </span>
                  )}
                  {ticket.displayTitle}
                  {isComplete && (
                    <span className="check-icon">
                      <i className="fa fa-check"></i>
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        </div>

        {currentTicket && allFormsData[currentAttendeeInstance?.attendeeId] ? (
          <div>
            <div
              style={{
                backgroundColor: "#f8fafc",
                padding: "16px",
                borderRadius: "8px",
                marginBottom: "16px",
                border: "1px solid #e2e8f0",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: "600",
                  textTransform: "capitalize",
                  color: "#1e293b",
                }}
              >
                {currentTicket.displayTitle}
              </h3>
              {currentTicket.description && 
                <p
                style={{
                  margin: "4px 0 0 0",
                  fontSize: "14px",
                  color: "#64748b",
                }}
              >
                {currentTicket.description}
              </p>
              }
              <p
                style={{
                  margin: "4px 0 0 0",
                  fontSize: "14px",
                  color: "#64748b",
                }}
              >
                {currentTicket.instanceType === "main"
                  ? "Main Ticket"
                  : "Guest Ticket"}{" "}
                - {currentTicket.currency}{" "}
                {currentTicket.price.toLocaleString()}
              </p>
            </div>

            {currentTicket.attendeeInstances.length > 1 && (
              <div
                className="attendee-tabs attendee-tabs-custom"
                style={{ marginBottom: "16px" }}
              >
                <div style={{ display: "flex", gap: "8px", overflow: "auto" }}>
                  {currentTicket.attendeeInstances.map(
                    (attendeeInstance, index) => {
                      const isAttendeeComplete =
                        validateAttendee(attendeeInstance.attendeeId) &&
                        savedAttendees[attendeeInstance.attendeeId];

                      return (
                        <button
                          key={attendeeInstance.attendeeId}
                          onClick={() =>
                            handleAttendeeTabClick(activeTicketTab, index)
                          }
                          className={`attendee-btn-custom ${
                            currentAttendeeIndex === index ? "active" : ""
                          } ${isAttendeeComplete ? "complete" : ""}`}
                        >
                          {isAttendeeComplete && (
                            <span className="check-icon">
                              <i className="fa fa-check"></i>
                            </span>
                          )}
                          Attendee {index + 1}
                        </button>
                      );
                    }
                  )}
                </div>
              </div>
            )}
            {currentAttendeeInstance && (
              <div className="attendee-form">
                {currentTicket.instanceType === "guest" &&
                  mainAttendees.filter((m) =>
                    m.value.startsWith(
                      currentTicket.originalTicketId + "-main-"
                    )
                  ).length > 0 && (
                    <div
                      className="form-group"
                      style={{ marginBottom: "16px" }}
                    >
                      <label
                        htmlFor={`${currentAttendeeInstance.attendeeId}-selectedMain`}
                        className="form-label"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#374151",
                          marginBottom: "8px",
                        }}
                      >
                        Accompanying with
                        <span
                          style={{
                            color: "#ef4444",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          *
                        </span>
                      </label>
                      <select
                        id={`${currentAttendeeInstance.attendeeId}-selectedMain`}
                        className="form-input"
                        style={{
                          width: "100%",
                          padding: "12px 16px",
                          border: errors[
                            `${currentAttendeeInstance.attendeeId}-selectedMain`
                          ]
                            ? "2px solid #ef4444"
                            : "2px solid #e5e7eb",
                          borderRadius: "8px",
                          fontSize: "16px",
                          transition: "all 0.2s ease",
                          outline: "none",
                          backgroundColor: errors[
                            `${currentAttendeeInstance.attendeeId}-selectedMain`
                          ]
                            ? "#fef2f2"
                            : "#fafafa",
                        }}
                        value={
                          allFormsData[currentAttendeeInstance.attendeeId]
                            ?.selectedMain || ""
                        }
                        onChange={(e) => {
                          const value = e.target.value;
                          console.log("Dropdown selected:", value);
                          setAllFormsData((prev) => ({
                            ...prev,
                            [currentAttendeeInstance.attendeeId]: {
                              ...(prev[currentAttendeeInstance.attendeeId] ||
                                {}),
                              selectedMain: value,
                            },
                          }));
                          const error = value
                            ? null
                            : "Please select the accompanying attendee";
                          setErrors((prev) => ({
                            ...prev,
                            [`${currentAttendeeInstance.attendeeId}-selectedMain`]:
                              error || "",
                          }));
                        }}
                      >
                        <option value="">Select an attendee</option>
                        {mainAttendees
                          .filter((m) =>
                            m.value.startsWith(
                              currentTicket.originalTicketId + "-main-"
                            )
                          )
                          .map(({ value, label }) => (
                            <option key={value} value={value}>
                              {label}
                            </option>
                          ))}
                      </select>
                      {errors[
                        `${currentAttendeeInstance.attendeeId}-selectedMain`
                      ] && (
                        <span
                          style={{
                            fontSize: "12px",
                            color: "#ef4444",
                            marginTop: "4px",
                            display: "block",
                            fontWeight: "500",
                          }}
                        >
                          {
                            errors[
                              `${currentAttendeeInstance.attendeeId}-selectedMain`
                            ]
                          }
                        </span>
                      )}
                    </div>
                  )}
                {allFormsData[currentAttendeeInstance.attendeeId]?.formDetails
                  ?.length > 0 ? (
                  allFormsData[
                    currentAttendeeInstance.attendeeId
                  ].formDetails.map((field) => {
                    // Detect if this attendee has membership number field
                    const hasMembershipField = allFormsData[
                      currentAttendeeInstance.attendeeId
                    ]?.formDetails?.some(
                      (f) => f.name === "amasimembership_number"
                    );

                    // Detect if current field is email
                    const isEmailField = field.name === "email_address";

                    return (
                      <div
                        key={field.id}
                        className="form-group"
                        style={{ marginBottom: "16px" }}
                      >
                        <label
                          htmlFor={`${currentAttendeeInstance.attendeeId}-${field.id}`}
                          className="form-label"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#374151",
                            marginBottom: "8px",
                          }}
                        >
                          {field.label}
                          {field.required && (
                            <span
                              style={{
                                color: "#ef4444",
                                fontSize: "16px",
                                fontWeight: "bold",
                              }}
                            >
                              *
                            </span>
                          )}
                        </label>

                        {/* Checkbox Field */}
                        {field.type === "checkbox" && (
                          <div className="checkbox-group">
                            {field.options?.map((option, index) => (
                              <div
                                key={`${field.id}-${index}`}
                                style={{ marginBottom: "8px" }}
                              >
                                <input
                                  type="checkbox"
                                  id={`${currentAttendeeInstance.attendeeId}-${field.id}-${index}`}
                                  className="form-input"
                                  checked={
                                    allFormsData[
                                      currentAttendeeInstance.attendeeId
                                    ]?.formData?.[field.id]?.[index] || false
                                  }
                                  onChange={(e) =>
                                    handleInputChange(
                                      currentAttendeeInstance.attendeeId,
                                      field.id,
                                      e.target.checked,
                                      index
                                    )
                                  }
                                  style={{
                                    marginRight: "8px",
                                    verticalAlign: "middle",
                                  }}
                                />
                                <label
                                  htmlFor={`${currentAttendeeInstance.attendeeId}-${field.id}-${index}`}
                                  style={{
                                    display: "inline",
                                    verticalAlign: "middle",
                                    fontSize: "16px",
                                    color: "#374151",
                                  }}
                                >
                                  {option}
                                </label>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* Radio Field */}
                        {field.type === "radio" && (
                          <div className="radio-group">
                            {field.options?.map((option, index) => (
                              <div
                                key={`${field.id}-${index}`}
                                style={{ marginBottom: "8px" }}
                              >
                                <input
                                  type="radio"
                                  id={`${currentAttendeeInstance.attendeeId}-${field.id}-${index}`}
                                  name={`${currentAttendeeInstance.attendeeId}-${field.id}`}
                                  className="form-input"
                                  value={option}
                                  checked={
                                    allFormsData[
                                      currentAttendeeInstance.attendeeId
                                    ]?.formData?.[field.id] === option
                                  }
                                  onChange={(e) =>
                                    handleInputChange(
                                      currentAttendeeInstance.attendeeId,
                                      field.id,
                                      e.target.value
                                    )
                                  }
                                  style={{
                                    marginRight: "8px",
                                    verticalAlign: "middle",
                                  }}
                                />
                                <label
                                  htmlFor={`${currentAttendeeInstance.attendeeId}-${field.id}-${index}`}
                                  style={{
                                    display: "inline",
                                    verticalAlign: "middle",
                                    fontSize: "16px",
                                    color: "#374151",
                                  }}
                                >
                                  {option}
                                </label>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* File Upload */}
                        {field.type === "file" && (
                          <FileUploadField
                            field={field}
                            attendeeId={currentAttendeeInstance.attendeeId}
                            value={
                              allFormsData[currentAttendeeInstance.attendeeId]
                                ?.formData?.[field.id] || null
                            }
                            isUploading={
                              isUploading[
                                `${currentAttendeeInstance.attendeeId}-${field.id}`
                              ] || false
                            }
                            error={
                              errors[
                                `${currentAttendeeInstance.attendeeId}-${field.id}`
                              ]
                            }
                            onFileChange={(formData) =>
                              uploadAndSet(
                                currentAttendeeInstance.attendeeId,
                                field.id,
                                formData
                              )
                            }
                            onUploadStart={() =>
                              setIsUploading((prev) => ({
                                ...prev,
                                [`${currentAttendeeInstance.attendeeId}-${field.id}`]: true,
                              }))
                            }
                            onUploadEnd={() =>
                              setIsUploading((prev) => ({
                                ...prev,
                                [`${currentAttendeeInstance.attendeeId}-${field.id}`]: false,
                              }))
                            }
                            onFileRemove={() => {
                              setAllFormsData((prev) => ({
                                ...prev,
                                [currentAttendeeInstance.attendeeId]: {
                                  ...prev[currentAttendeeInstance.attendeeId],
                                  formData: {
                                    ...prev[currentAttendeeInstance.attendeeId]
                                      .formData,
                                    [field.id]: null,
                                  },
                                },
                              }));
                              setErrors((prev) => ({
                                ...prev,
                                [`${currentAttendeeInstance.attendeeId}-${field.id}`]:
                                  "",
                              }));
                            }}
                          />
                        )}

                        {/* Select Dropdown */}
                        {field.type === "select" && (
                          <select
                            id={`${currentAttendeeInstance.attendeeId}-${field.id}`}
                            className="form-input"
                            style={{
                              width: "100%",
                              padding: "12px 16px",
                              border: errors[
                                `${currentAttendeeInstance.attendeeId}-${field.id}`
                              ]
                                ? "2px solid #ef4444"
                                : "2px solid #e5e7eb",
                              borderRadius: "8px",
                              fontSize: "16px",
                              transition: "all 0.2s ease",
                              outline: "none",
                              backgroundColor: errors[
                                `${currentAttendeeInstance.attendeeId}-${field.id}`
                              ]
                                ? "#fef2f2"
                                : "#fafafa",
                            }}
                            value={
                              allFormsData[currentAttendeeInstance.attendeeId]
                                ?.formData?.[field.id] || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                currentAttendeeInstance.attendeeId,
                                field.id,
                                e.target.value
                              )
                            }
                          >
                            <option value="">Select an option</option>
                            {field.options?.map((option, index) => (
                              <option key={index} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        )}

                        {/* Text / Email / Tel / Number Fields */}
                        {field.type !== "checkbox" &&
                          field.type !== "radio" &&
                          field.type !== "file" &&
                          field.type !== "select" && (
                            <>
                              {field.name === "amasimembership_number" ? (
                                <div
                                  className="membership-input-wrapper"
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                    marginBottom: "16px",
                                  }}
                                >
                                  <div style={{ position: "relative" }}>
                                    {/* Membership Number Input */}
                                    <input
                                      type={field.type}
                                      id={`${currentAttendeeInstance.attendeeId}-${field.id}`}
                                      className="form-input"
                                      placeholder={
                                        field.placeholder ||
                                        "Enter AMASI Membership Reg.email"
                                      }
                                      value={
                                        allFormsData[
                                          currentAttendeeInstance.attendeeId
                                        ]?.formData?.[field.id] || ""
                                      }
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        const attendeeId =
                                          currentAttendeeInstance.attendeeId;

                                        handleInputChange(
                                          attendeeId,
                                          field.id,
                                          value
                                        );

                                        setErrors((prev) => {
                                          const key = `${attendeeId}-${field.id}`;
                                          if (prev[key]) {
                                            const { [key]: _, ...rest } = prev;
                                            return rest;
                                          }
                                          return prev;
                                        });
                                      }}
                                      style={{
                                        width: "100%",
                                        padding: "12px 44px 12px 16px",
                                        borderRadius: "8px",
                                        border: `2px solid ${
                                          errors[
                                            `${currentAttendeeInstance.attendeeId}-${field.id}`
                                          ]
                                            ? "#ef4444"
                                            : verifiedMemberships[
                                                currentAttendeeInstance
                                                  .attendeeId
                                              ]
                                            ? "#10b981"
                                            : "#d1d5db"
                                        }`,
                                        fontSize: "16px",
                                        outline: "none",
                                        backgroundColor: errors[
                                          `${currentAttendeeInstance.attendeeId}-${field.id}`
                                        ]
                                          ? "#fef2f2"
                                          : "#ffffff",
                                        transition: "all 0.2s ease",
                                        boxShadow: verifiedMemberships[
                                          currentAttendeeInstance.attendeeId
                                        ]
                                          ? "0 0 0 1px #10b981"
                                          : "none",
                                      }}
                                    />

                                    {/* Verify Button */}
                                    <button
                                      type="button"
                                      onClick={() => {
                                        const value =
                                          allFormsData[
                                            currentAttendeeInstance.attendeeId
                                          ]?.formData?.[field.id] || "";

                                        // Clear auto-filled fields on verify
                                        clearAutoFilledFields(
                                          currentAttendeeInstance.attendeeId
                                        );
                                        setVerifiedMemberships((prev) => {
                                          const {
                                            [currentAttendeeInstance.attendeeId]:
                                              _,
                                            ...rest
                                          } = prev;
                                          return rest;
                                        });

                                        if (value.trim()) {
                                          fetchMemberDetails(
                                            currentAttendeeInstance.attendeeId,
                                            value
                                          );
                                        }
                                      }}
                                      disabled={
                                        isSubmitting ||
                                        !allFormsData[
                                          currentAttendeeInstance.attendeeId
                                        ]?.formData?.[field.id]?.trim()
                                      }
                                      style={{
                                        position: "absolute",
                                        right: "12px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        background: "transparent",
                                        border: "none",
                                        cursor:
                                          !allFormsData[
                                            currentAttendeeInstance.attendeeId
                                          ]?.formData?.[field.id]?.trim() ||
                                          isSubmitting
                                            ? "not-allowed"
                                            : "pointer",
                                        opacity:
                                          !allFormsData[
                                            currentAttendeeInstance.attendeeId
                                          ]?.formData?.[field.id]?.trim() ||
                                          isSubmitting
                                            ? 0.5
                                            : 1,
                                        padding: "4px",
                                        borderRadius: "4px",
                                      }}
                                      title="Click to verify membership number"
                                    >
                                      {verifiedMemberships[
                                        currentAttendeeInstance.attendeeId
                                      ] ? (
                                        <span
                                          style={{
                                            color: "#10b981",
                                            fontSize: "18px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          <button
                                            style={{
                                              padding: "8px 16px",
                                              backgroundColor: "#10b981",
                                              color: "white",
                                              border: "none",
                                              borderRadius: "8px",
                                              fontSize: "14px",
                                            }}
                                          >
                                            Verify
                                          </button>
                                        </span>
                                      ) : isUploading[
                                          currentAttendeeInstance.attendeeId
                                        ] ? (
                                        <span
                                          style={{
                                            color: "#3b82f6",
                                            fontSize: "16px",
                                          }}
                                        >
                                          Loading...
                                        </span>
                                      ) : (
                                        <button
                                          style={{
                                            padding: "8px 16px",
                                            backgroundColor: "#10b981",
                                            color: "white",
                                            border: "none",
                                            borderRadius: "8px",
                                            fontSize: "14px",
                                          }}
                                        >
                                          Verify
                                        </button>
                                      )}
                                    </button>
                                  </div>

                                  {/* Error Message */}
                                  {errors[
                                    `${currentAttendeeInstance.attendeeId}-${field.id}`
                                  ] && (
                                    <p
                                      style={{
                                        color: "#ef4444",
                                        fontSize: "13px",
                                        margin: "6px 0 0",
                                        fontWeight: "500",
                                      }}
                                    >
                                      {
                                        errors[
                                          `${currentAttendeeInstance.attendeeId}-${field.id}`
                                        ]
                                      }
                                    </p>
                                  )}

                                  {/* Success Message */}
                                  {verifiedMemberships[
                                    currentAttendeeInstance.attendeeId
                                  ] &&
                                    !errors[
                                      `${currentAttendeeInstance.attendeeId}-${field.id}`
                                    ] && (
                                      <p
                                        style={{
                                          color: "#10b981",
                                          fontSize: "13px",
                                          margin: "6px 0 0",
                                          fontWeight: "500",
                                        }}
                                      >
                                        Your Membership Number{" "}
                                        <span
                                          style={{
                                            color: "#dc2626",
                                            backgroundColor: "#fef2f2",
                                            padding: "2px 6px",
                                            borderRadius: "4px",
                                            fontWeight: "600",
                                          }}
                                        >
                                          {membershipNumber}
                                        </span>{" "}
                                        - Verified successfully
                                      </p>
                                    )}

                                  <Alert
                                    variant="info"
                                    style={{
                                      background: "#e3f2fd",
                                      border: "1px solid #bbdefb",
                                      borderRadius: "8px",
                                      padding: "12px 15px",
                                      margin: "10px 0 20px",
                                      fontSize: "14px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                      }}
                                    >
                                      <FaInfoCircle size={23}/>
                                      <span>
                                        You can fetch your existing AMASI
                                        membership details using your registered{" "}
                                        {/* <strong>email</strong> or{" "} */}
                                        <strong>AMASI number</strong>. If you
                                        don’t have a membership number yet,{" "}
                                        <a
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          href="https://application.amasi.org/application/user-member-application-list"
                                          style={{
                                            color: "#1976d2",
                                            fontWeight: "600",
                                            textDecoration: "underline",
                                            cursor: "pointer",
                                          }}
                                        >
                                          click here to create a new membership
                                        </a>
                                        .
                                      </span>
                                    </div>
                                  </Alert>
                                </div>
                              ) : (
                                /* Regular Input – Email Disabled if Membership Exists */
                                <input
                                  type={field.type}
                                  id={`${currentAttendeeInstance.attendeeId}-${field.id}`}
                                  className="form-input"
                                  placeholder={field.placeholder}
                                  value={
                                    allFormsData[
                                      currentAttendeeInstance.attendeeId
                                    ]?.formData?.[field.id] || ""
                                  }
                                  onChange={(e) =>
                                    handleInputChange(
                                      currentAttendeeInstance.attendeeId,
                                      field.id,
                                      e.target.value
                                    )
                                  }
                                  disabled={hasMembershipField && isEmailField}
                                  style={{
                                    width: "100%",
                                    padding: "12px 16px",
                                    borderRadius: "8px",
                                    border: errors[
                                      `${currentAttendeeInstance.attendeeId}-${field.id}`
                                    ]
                                      ? "2px solid #ef4444"
                                      : "2px solid #e5e7eb",
                                    fontSize: "16px",
                                    outline: "none",
                                    backgroundColor:
                                      hasMembershipField && isEmailField
                                        ? "#e5e7eb"
                                        : errors[
                                            `${currentAttendeeInstance.attendeeId}-${field.id}`
                                          ]
                                        ? "#fef2f2"
                                        : "#fafafa",
                                    transition: "all 0.2s ease",
                                    cursor:
                                      hasMembershipField && isEmailField
                                        ? "not-allowed"
                                        : "text",
                                  }}
                                />
                              )}
                            </>
                          )}

                        {/* General Error Message (outside conditional) */}
                        {errors[
                          `${currentAttendeeInstance.attendeeId}-${field.id}`
                        ] && (
                          <span
                            style={{
                              fontSize: "12px",
                              color: "#ef4444",
                              marginTop: "4px",
                              display: "block",
                              fontWeight: "500",
                            }}
                          >
                            {
                              errors[
                                `${currentAttendeeInstance.attendeeId}-${field.id}`
                              ]
                            }
                          </span>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <p
                    style={{
                      fontSize: "14px",
                      color: "#64748b",
                      marginBottom: "16px",
                    }}
                  >
                    No form fields required for this attendee.
                  </p>
                )}

                {allFormsData[
                  currentAttendeeInstance?.attendeeId
                ]?.addons?.filter((addon) => addon.addon_status === "onsale")
                  .length > 0 && (
                  <div className="addons-section" style={{ marginTop: "24px" }}>
                    <h4
                      style={{
                        fontSize: "18px",
                        fontWeight: "600",
                        marginBottom: "16px",
                      }}
                    >
                      Available Add-ons
                    </h4>
                    <div className="avalable_add_height">
                      {allFormsData[currentAttendeeInstance?.attendeeId].addons
                        .filter((addon) => addon.addon_status === "onsale")
                        .map((addon) => (
                          <div
                            key={addon.id}
                            className=" add_flex_addon custom_addon_item"
                            style={{ marginBottom: "16px" }}
                          >
                            {addon.addons_type === "variant" ? (
                              addon.variant_options.map((variant, index) => {
                                const v_rate =
                                  addon.tax_options.reduce(
                                    (sum, t) =>
                                      sum +
                                      (Number.parseFloat(t.tax_percentage) ||
                                        0),
                                    0
                                  ) / 100;
                                let v_showPrice = Number(variant.variant_price);
                                let priceDetails = "";
                                if (addon.tax_type === "No Tax") {
                                  priceDetails = "No Tax";
                                } else if (addon.tax_type === "Including Tax") {
                                  priceDetails = `Incl. ${taxName}`;
                                } else if (addon.tax_type === "Excluding Tax") {
                                  v_showPrice += v_showPrice * v_rate;
                                  priceDetails = `Excl. ${taxName}`;
                                }
                                v_showPrice =
                                  Math.round(v_showPrice * 100) / 100;

                                const selectedVariant =
                                  addon.selectedVariants?.find(
                                    (sv) =>
                                      sv.variant_name === variant.variant_name
                                  ) || { quantity: 0 };
                                const isSelected = selectedVariant.quantity > 0;
                                const quantity = selectedVariant.quantity;

                                return (
                                  <div
                                    key={index}
                                    className="addon-item"
                                    style={{ marginBottom: "16px" }}
                                  >
                                    <div className="addon-info">
                                      <h5
                                        style={{
                                          fontSize: "16px",
                                          fontWeight: "600",
                                        }}
                                      >
                                        {addon.add_on_name} -{" "}
                                        {variant.variant_name}
                                        {addon.isMandatory && (
                                          <span
                                            className="mandatory-badge"
                                            style={{
                                              color: "#ef4444",
                                              fontSize: "12px",
                                              marginLeft: "8px",
                                            }}
                                          >
                                            Mandatory
                                          </span>
                                        )}
                                      </h5>
                                      <p
                                        style={{
                                          fontSize: "14px",
                                          color: "#64748b",
                                        }}
                                      >
                                        {addon.description}
                                      </p>
                                      <div
                                        className="addon-pricing"
                                        style={{ marginTop: "8px" }}
                                      >
                                        <span style={{ fontSize: "14px" }}>
                                          {addon.currency}{" "}
                                          {v_showPrice.toLocaleString()}
                                        </span>
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            color: "#64748b",
                                            marginLeft: "8px",
                                          }}
                                        >
                                          {priceDetails}
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="addon-actions"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        marginTop: "8px",
                                      }}
                                    >
                                      <button
                                        onClick={() =>
                                          toggleAddon(
                                            currentAttendeeInstance.attendeeId,
                                            addon.id,
                                            variant
                                          )
                                        }
                                        disabled={
                                          addon.addon_status !== "onsale" ||
                                          (addon.isMandatory &&
                                            isSelected &&
                                            quantity > 0)
                                        }
                                        className={`btn ${
                                          isSelected
                                            ? "btn-danger"
                                            : "btn-outline"
                                        }`}
                                        style={{
                                          padding: "8px 16px",
                                          fontSize: "14px",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "4px",
                                        }}
                                      >
                                        {isSelected ? (
                                          <>
                                            <Trash2 className="icon-sm" />
                                          </>
                                        ) : (
                                          <>
                                            Add <Plus className="icon-sm" />
                                          </>
                                        )}
                                      </button>
                                      {isSelected && (
                                        <div
                                          className="quantity-controls"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                          }}
                                        >
                                          <button
                                            onClick={() =>
                                              updateAddonQuantity(
                                                currentAttendeeInstance.attendeeId,
                                                addon.id,
                                                -1,
                                                variant.variant_name
                                              )
                                            }
                                            disabled={quantity === 0}
                                            className="quantity-btn"
                                            style={{ padding: "8px" }}
                                          >
                                            <Minus className="icon-sm" />
                                          </button>
                                          <span
                                            className="quantity-display"
                                            style={{ fontSize: "14px" }}
                                          >
                                            {quantity}
                                          </span>
                                          <button
                                            onClick={() =>
                                              updateAddonQuantity(
                                                currentAttendeeInstance.attendeeId,
                                                addon.id,
                                                1,
                                                variant.variant_name
                                              )
                                            }
                                            disabled={
                                              quantity >=
                                              (addon.maxQuantity || 1)
                                            }
                                            className="quantity-btn"
                                            style={{ padding: "8px" }}
                                          >
                                            <Plus className="icon-sm" />
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div
                                className="addon-item"
                                style={{ marginBottom: "16px" }}
                              >
                                <div className="addon-info">
                                  <h5
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {addon.add_on_name}
                                    {addon.isMandatory && (
                                      <span
                                        className="mandatory-badge"
                                        style={{
                                          color: "#ef4444",
                                          fontSize: "12px",
                                          marginLeft: "8px",
                                        }}
                                      >
                                        Mandatory
                                      </span>
                                    )}
                                  </h5>
                                  <p
                                    style={{
                                      fontSize: "14px",
                                      color: "#64748b",
                                    }}
                                  >
                                    {addon.description}
                                  </p>
                                  <div
                                    className="addon-pricing"
                                    style={{ marginTop: "8px" }}
                                  >
                                    <span style={{ fontSize: "14px" }}>
                                      {addon.currency}{" "}
                                      {(
                                        Number(addon.price) || 0
                                      ).toLocaleString()}
                                    </span>
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        color: "#64748b",
                                        marginLeft: "8px",
                                      }}
                                    >
                                      {addon.tax_type === "No Tax"
                                        ? "No Tax"
                                        : addon.tax_type === "Including Tax"
                                        ? `Incl. ${taxName}`
                                        : `Excl. ${taxName}`}
                                    </span>
                                  </div>
                                </div>
                                <div
                                  className="addon-actions"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    marginTop: "8px",
                                  }}
                                >
                                  <button
                                    onClick={() =>
                                      toggleAddon(
                                        currentAttendeeInstance.attendeeId,
                                        addon.id
                                      )
                                    }
                                    disabled={
                                      addon.addon_status !== "onsale" ||
                                      (addon.isMandatory && addon.isAdded)
                                    }
                                    className={`btn ${
                                      addon.isAdded
                                        ? "btn-danger"
                                        : "btn-outline"
                                    }`}
                                    style={{
                                      padding: "8px 16px",
                                      fontSize: "14px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "4px",
                                    }}
                                  >
                                    {addon.isAdded ? (
                                      <>
                                        <Trash2 className="icon-sm" />
                                      </>
                                    ) : (
                                      <>
                                        Add <Plus className="icon-sm" />
                                      </>
                                    )}
                                  </button>
                                  {addon.isAdded && (
                                    <div
                                      className="quantity-controls"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                      }}
                                    >
                                      <button
                                        onClick={() =>
                                          updateAddonQuantity(
                                            currentAttendeeInstance.attendeeId,
                                            addon.id,
                                            -1
                                          )
                                        }
                                        disabled={
                                          addon.quantity === 0 ||
                                          (addon.isMandatory &&
                                            addon.quantity <= 1)
                                        }
                                        className="quantity-btn"
                                        style={{ padding: "8px" }}
                                      >
                                        <Minus className="icon-sm" />
                                      </button>
                                      <span
                                        className="quantity-display"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {addon.quantity}
                                      </span>
                                      <button
                                        onClick={() =>
                                          updateAddonQuantity(
                                            currentAttendeeInstance.attendeeId,
                                            addon.id,
                                            1
                                          )
                                        }
                                        disabled={
                                          addon.quantity >=
                                          (addon.maxQuantity || 1)
                                        }
                                        className="quantity-btn"
                                        style={{ padding: "8px" }}
                                      >
                                        <Plus className="icon-sm" />
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                )}
                <div className="save_button_addon">
                  {currentAttendeeInstance &&
                    (() => {
                      const attendeeId = currentAttendeeInstance.attendeeId;
                      const membershipField = allFormsData[
                        attendeeId
                      ]?.formDetails?.find(
                        (f) => f.name === "amasimembership_number"
                      );
                      const hasMembershipField = !!membershipField;
                      const membershipVerified = hasMembershipField
                        ? !!verifiedMemberships[attendeeId]
                        : true;
                      const isSaved = !!savedAttendees[attendeeId];

                      const isDisabled =
                        isSubmitting ||
                        (hasMembershipField && !membershipVerified);
                      const tooltipText =
                        hasMembershipField && !membershipVerified
                          ? "First verify with member number"
                          : "";

                      const handleSave = () => {
                        const isValid = validateAttendee(attendeeId);
                        if (isValid && membershipVerified) {
                          saveCurrentAttendee(attendeeId, currentTicket);
                        } else {
                          validateAllForms(); // Show all field errors
                          if (hasMembershipField && !membershipVerified) {
                            showToast(
                              "Please verify with the membership number",
                              "error"
                            );
                          } else {
                            showToast(
                              "Please fill all required",
                              "error"
                            );
                          }
                        }
                      };

                      return (
                        <button
                          onClick={handleSave}
                          disabled={isDisabled}
                          title={tooltipText}
                          style={{
                            marginTop: "16px",
                            padding: "8px 16px",
                            backgroundColor:
                              isSaved && membershipVerified
                                ? "#10b981"
                                : "#3b82f6",
                            color: "white",
                            border: "none",
                            borderRadius: "8px",
                            cursor: isDisabled ? "not-allowed" : "pointer",
                            opacity: isDisabled ? 0.6 : 1,
                            position: "relative",
                          }}
                        >
                          {isSubmitting
                            ? "Saving..."
                            : isSaved && membershipVerified
                            ? "Save Attendee"
                            : "Save Attendee"}
                        </button>
                      );
                    })()}
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="loader-container">
            <div className="spinner"></div>
            <p>Loading...</p>
          </div>
        )}
      </div>

      <div className="sticky-bottom w-full">
        <div className="floating-element"></div>
        <div className="floating-element"></div>
        <div className="floating-element"></div>
        <div className="floating-element"></div>
        <div className="total-section">
          <div className="total-info">
            <div
              className="total-price"
              onClick={() => setIsDetailsVisible(!isDetailsVisible)}
              style={{ cursor: "pointer", userSelect: "none" }}
            >
              {currentTicket?.currency || "INR"}{" "}
              {grandTotal.toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
              <span>
                {isDetailsVisible ? <FaChevronDown /> : <FaChevronUp />}
              </span>
            </div>
            {isDetailsVisible && (
              <div
                className="total-details"
                style={{ marginTop: "8px", fontSize: "14px", color: "#64748b" }}
              >
                Subtotal: {currentTicket?.currency || "INR"}{" "}
                {Math.round(totalSubtotal).toLocaleString()}
                <br />
                {totalTaxName}: {currentTicket?.currency || "INR"}{" "}
                {Math.round(totalTax).toLocaleString()}
              </div>
            )}
          </div>
          <div style={{ display: "flex", gap: "8px" }}>
            <button
              className="btn btn-outline"
              onClick={handleBack}
              style={{ padding: "8px 16px" }}
              disabled={isSubmitting}
            >
              Back
            </button>
            <button
              className="btn btn-primary"
              onClick={handleProceed}
              disabled={!areAllTicketsComplete() || isSubmitting}
              style={{ padding: "8px 16px" }}
            >
              {isSubmitting ? "Saving..." : "Proceed"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttendeeDetails;
